import React from 'react';

//公共地址配置
import configUrl from '../../default';

import { graphicManage, getPolygonArea } from '../MapToolFunction';
import Immutable from 'immutable';
import { isArray, isEmpty } from 'lodash';
const { Set } = Immutable;

class OlMap extends React.Component {
    constructor(props) {
        super(props);
        this.zIndexGraphics = []; //需要放在最后的图元,zoom和pan时刷新dom到最后
        this.htmlPointsId = 'vtx_gmap_html_points'; //html点位容器id class管理
        this.pointCollectionId = 'vtx_gmap_html_pointCollection'; //海量点canvas点位容器id class管理
        this.Label = {}; //所有label 集合
        this.labelLayer = { x: 0, y: 0 }; //label图层 位置管理
        this.viewer = null;
        this.GM = new graphicManage(); //初始化 图元管理方法
        this.getPolygonArea = getPolygonArea;
        this.layer = null; //保存地图图层数据
        this.loadTimer = null; //初始化地图 load时延缓数据处理
        this.animTimer = {}; //点位跳动动画 定时集合
        this.animCount = {}; //点位跳动动画 定时计数
        this.moveToTimer = null; //moveTo时间对象
        this.drawToolbar = null; //地图绘制对象即interaction
        this.drawParam = {}; //缓存 绘制的数据
        this.editToolbar = null; //编辑对象
        this.editId = ''; //当前编辑的图元id
        this.drawSource = null;
        this.drawVector = null;
        // 图元绘制保存
        this.drawInfo = {
            sketch: null,
            listener: null,
        };
        this.scaleControl = null;
        this.pointLayers = [];
        this.mouseNowPosition = { x: 0, y: 0, px: 0, py: 0, isCount: false };
        this.heatmap = null; //热力图对象
        this.clusterMarkers = []; //聚合点位id数组
        this.clusterPs = []; //聚合集合点
        this.clusterPt = []; //地图中聚合点集合
        this.morepoints = []; //海量点集合
        this.areaRestriction = null; //区域限制数据
        this.movePoints = [];
        this.olLayers = []; // ol图层集合 {address:'', layer: ''}
        //是否绘制测距
        this.rangingTool = {
            isRanging: false, //是否开启状态
            line: {}, //线
            points: [], //点
            distance: 0, //测距长度
            mapRangingTool: null, //测距回调
        };
        this.rangingTools = {}; //测距点线缓存
        this.rangingInfo = {
            sketch: null,
            helpTooltipElement: null,
            helpTooltip: null,
            measureTooltipElement: null,
            measureTooltip: null,
            deleteToolTipElement: null,
            deleteToolTip: null,
            continuePolygonMsg: '点击继续绘制图形',
            continueLineMsg: '点击继续绘制线',
            listener: null,
            drawElements: [],
            drawLayer: null,
            feature: null,
            draw: null,
        }
        this.clusterInfo = {
            clickFeature: null,
            clickResolution: null,
            hoverFeature: null,
            clusterSource: null,
            clusterHulls: null,
            clusters: null,
            clusterCircles: null,
        };
        this.state = {
            gis: null, //地图对象
            mapId: props.mapId,
            mapCreated: false,
            pointIds: [], //地图上点的ids
            lineIds: [], //地图上线的ids
            polygonIds: [], //地图上面的ids
            circleIds: [], //地图上圆的ids
            editGraphic: '', //当前编辑完后图元所有数据
            boundaryInfo: [], //当前画出的边界线的id和区域名
            drawIds: {
                //绘制工具id集合
                point: [],
                polyline: [],
                polygon: [],
                circle: [],
                rectangle: [],
            },
        };
        this.loadMapJs();
    }
    // 引入ol样式
    loadMapJs() {
        this.loadMapComplete = new Promise((resolve, reject) => {
            if (window.OlMap) {
                resolve(window.OlMap);
            } else {
                $.getScript(`${configUrl.openlayerServerURL}/ol.js`, () => {
                    let PointCollection = new Promise((resolve, reject) => {
                        $.getScript(`${configUrl.mapServerURL}/GPointCollection.js`, () => {
                            resolve();
                        });
                    });
                    let Client9 = new Promise(function (resolve, reject) {
                        $.getScript(`${configUrl.openlayerServerURL}/iclient-openlayers.min.js`, function () {
                            resolve();
                        });
                    });
                    Promise.all([PointCollection, Client9]).then(() => {
                        resolve(window.OlMap);
                    })
                });
                $.getScript(`${configUrl.openlayerServerURL}/bd09.js`);
                $.getScript(`${configUrl.openlayerServerURL}/olScreen.js`);
                $('<link>')
                    .attr({
                        rel: 'stylesheet',
                        type: 'text/css',
                        href:
                            `${configUrl.openlayerServerURL}/ol.css`,
                    })
                    .appendTo('head');
            }
        });
    }
    // 初始化地圖
    init() {
        let t = this;
        // 创建地图
        t.createMap();
        t.drawSource = new ol.source.Vector({ wrapX: false });
        t.drawVector = new ol.layer.Vector({ source: t.drawSource });
        let initData = () => {
            const {
                mapPoints,
                mapLines,
                mapPolygons,
                mapCircles,
                mapVisiblePoints,
                mapCluster,
                mapPointCollection,
                areaRestriction,
                heatMapData
            } = t.props;
            // 初始化中心点
            t.setCenter();
            // 添加点
            if (mapPoints instanceof Array) {
                t.addPoint(mapPoints);
            }
            //添加线
            if (mapLines instanceof Array) {
                t.addLine(mapLines);
            }
            //添加面
            if (mapPolygons instanceof Array) {
                t.addPolygon(mapPolygons);
            }
            //添加圆
            if (mapCircles instanceof Array) {
                t.addCircle(mapCircles);
            }
            //是否设置比例尺
            if (t.props.showControl) {
                t.showControl(t.props);
            }
            // 画热力图
            if (heatMapData) {
                t.heatMapOverlay(heatMapData);
            }
            //设置点聚合
            if (mapCluster instanceof Array) {
                t.cluster(mapCluster);
            }
            /*设置指定图元展示*/
            if (mapVisiblePoints) {
                t.setVisiblePoints(mapVisiblePoints);
            }
            //添加海量点
            if (mapPointCollection instanceof Array) {
                t.addPointCollection(mapPointCollection);
            }
            //设置区域限制
            if (areaRestriction && !!areaRestriction[0] && !!areaRestriction[1]) {
                t.setAreaRestriction(areaRestriction);
            }
            t.setState({
                mapCreated: true,
            });
        };
        let event = (e, status) => {
            const { gis } = t.state;
            let overall_feature = null; //鼠标移入事件时记录当前的feature，为鼠标移出要素时保存操作的要素对象
            let dragAddMoveFlag = false; //记录地图拖拽和移动事件
            // 地图开始加载时
            gis.on('loadstart', function () {
                gis.getTargetElement().classList.add('spinner');
            });
            // 地图加载结束时
            gis.on('loadend', function () {
                gis.getTargetElement().classList.remove('spinner');
            });
            // 地图双击事件
            gis.on('dbclick', evt => { });
            // 地图点击事件
            gis.on('singleclick', evt => {
                let feature = gis.forEachFeatureAtPixel(evt.pixel, feature => feature);
                if (feature) {
                    let target = feature.getProperties();
                    //  top: e.clientY,//当前点所在的位置(屏幕)
                    // left: e.clientX,
                    t.clickGraphic(target.id, evt);
                } else {
                    t.clickMap(evt);
                }
            });
            // 鼠标移动事件 - 当鼠标指向要素时改变光标状态
            gis.on('pointermove', evt => {
                let pixel = gis.getEventPixel(evt.originalEvent);
                let hit = gis.hasFeatureAtPixel(pixel);
                gis.getTargetElement().style.cursor = hit ? 'pointer' : 'default';
                // 获取到当前鼠标移动下的feature
                let feature = gis.forEachFeatureAtPixel(pixel, function (feature, layer) {
                    return feature;
                });
                if (feature) {
                    overall_feature = feature;
                    let values = feature.getProperties();
                    t.mouseOverGraphic(values.id, evt);
                } else {
                    if (overall_feature) {
                        overall_feature.dispatchEvent({ type: 'mousein', event: evt });
                        let values = overall_feature.getProperties();
                        t.mouseOutGraphic(values.id, evt);
                        overall_feature = null;
                    }
                }
            });
            // 鼠标拖拽事件 - 拖拽开始即是地图移动开始
            gis.on('pointerdrag', evt => {
                dragAddMoveFlag = true;
                t.dragMapStart(evt);
                t.moveStart(evt);
            });
            let zoom = 0;
            // 地图移动事件 - 移动结束即是拖拽事件结束 也是地图缩放事件（无开始和结束事件）的监听
            gis.on('moveend', evt => {
                t.dragMapEnd(evt);
                t.moveEnd(evt);
                t.zoomStart(evt);
                setTimeout(() => {
                    t.zoomEnd(evt);
                }, 300);
                dragAddMoveFlag = false;
            });
            // gis.getViewport().addEventListener('mouseout', function () {
            //     helpTooltipElement.classList.add('hidden');
            // });
        };
        event();
        t.setCenter(t.props.center);
        initData();
    }
    // 创建地图
    createMap() {
        let t = this;
        let {
            olProps = {},
            mapCenter = [],
            mapId,
            mapZoomLevel,
            minZoom,
            maxZoom,
        } = t.props;
        let {
            projection, // 坐标投影类型 EPSG:4326和EPSG:3857,百度图层使用自定义的'BD:09'
            olCoverage
        } = olProps;
        if (window.VtxMap) {
            window.VtxMap[mapId] = null;
        } else {
            window.VtxMap = {};
        }
        if (!minZoom) {
            minZoom = 2
        }
        if (!maxZoom) {
            maxZoom = 19
        }
        if (!projection) {
            projection = 'EPSG:4326'
        }
        //中心点
        let center = mapCenter && mapCenter instanceof Array && mapCenter.length == 2
            ? mapCenter
            : [116.400433, 39.906705];
        center = [parseFloat(center[0]), parseFloat(center[1])];
        window.VtxMap[mapId] = t.state.gis = new ol.Map({
            target: mapId.toString(),
            view: new ol.View({
                center: center,
                zoom: mapZoomLevel || 10,
                projection,
                minZoom,
                maxZoom,
            }),
            controls: ol.control.defaults({
                zoom: false,
                rotate: false,
                attribution: false
            }),
        });
        // 基本地图视图
        t.viewer = new ol.View({
            center: center,
            zoom: mapZoomLevel || 10,
            projection,
            minZoom,
            maxZoom,
        })
        t.loadLayers(olCoverage, [], true);
        t.initPropsForUser();
    }
    // 加载图层
    loadLayers = (nextLayers = [], currentLayers = [], first = false) => {
        const t = this;
        // 对比图层的变化，找出需要新增和需要删除的。
        const addLayers = nextLayers.filter(item => {
            return !currentLayers.map(e => e.coverage).includes(item.coverage)
        });
        const removeLayers = currentLayers.filter(item => {
            return !nextLayers.map(e => e.coverage).includes(item.coverage)
        })
        if (removeLayers.length > 0) {
            removeLayers.forEach(item => {
                const exist = t.olLayers.find(e => e.address === item.coverage);
                exist && exist.layer.setVisible(false);
            })
        }
        if (addLayers.length > 0) {
            addLayers.map(item => {
                if (
                    item.coverage.startsWith("http") ||
                    item.coverage.startsWith('/')
                ) {
                    switch (item.type) {
                        // 超图
                        case 'superMap':
                            t.addSuperMapLayer(item.coverage);
                            break;
                        // geoServer_geoJSON
                        case 'geoServer':
                            t.addGeoServerLayer(item.coverage);
                        // geoServer_image
                        case 'geoServer_image':
                            t.addGeoServerImageLayer(item);
                        default:
                            break;
                    }
                } else if (item.coverage.indexOf("WMTS") > -1) {
                    t.addTileLayer(JSON.parse(item.coverage));
                } else if (OL_SCREEN[item.coverage]) {
                    if (first) {
                        let layers = eval(OL_SCREEN[item.coverage].initLayer);
                        if (isArray(layers)) {
                            layers.map(layer => {
                                t.state.gis.addLayer(layer);
                            })
                        } else {
                            t.state.gis.addLayer(layers);
                        }
                    }
                }
            })
        } else {
            if (first) {
                let layer = eval(OL_SCREEN.default.initLayer);
                t.state.gis.addLayer(layer);
            }
        }
    }

    // wmts图层资源
    getWMTS(options) {
        const { url, params, sourceOptions } = options;

        //切片名
        let matrixIds = [
            'EPSG:4326:0',
            'EPSG:4326:1',
            'EPSG:4326:2',
            'EPSG:4326:3',
            'EPSG:4326:4',
            'EPSG:4326:5',
            'EPSG:4326:6',
            'EPSG:4326:7',
            'EPSG:4326:8',
            'EPSG:4326:9',
            'EPSG:4326:10',
            'EPSG:4326:11',
            'EPSG:4326:12',
            'EPSG:4326:13',
            'EPSG:4326:14',
            'EPSG:4326:15',
            'EPSG:4326:16',
            'EPSG:4326:17',
            'EPSG:4326:18',
        ];

        //分辨率
        let resolutions = [
            0.703125,
            0.3515625,
            0.17578125,
            0.087890625,
            0.0439453125,
            0.02197265625,
            0.010986328125,
            0.0054931640625,
            0.00274658203125,
            0.001373291015625,
            6.866455078125e-4,
            3.4332275390625e-4,
            1.71661376953125e-4,
            8.58306884765625e-5,
            4.291534423828125e-5,
            2.1457672119140625e-5,
            1.0728836059570312e-5,
            5.364418029785156e-6,
            2.682209014892578e-6,
        ];

        //切片策略
        let tilegrid = new ol.tilegrid.WMTS({
            extent: [-180.0, -90.0, 180.0, 90.0], //范围
            tileSize: [256, 256],
            origin: [-180.0, 90.0], //切片原点
            resolutions: resolutions, //分辨率
            matrixIds: matrixIds, //层级标识列表，与地图级数保持一致
        });

        //设置地图投影
        let projection = new ol.proj.Projection({
            code: 'EPSG:4326',
            units: 'degrees',
            axisOrientation: 'neu',
        });

        return new ol.source.WMTS({
            url: url,
            layer: params?.layer,
            format: 'image/png',
            matrixSet: 'EPSG:4326',
            projection: projection,
            tileGrid: tilegrid,
            ...sourceOptions,
        });
    }

    // 添加普通图层
    addTileLayer({ url, params = {}, sourceOptions = {}, type, source }) {
        if (url) {
            const exist = this.olLayers.find(item => item.address === url);
            if (exist) {
                exist.layer.setVisible(true);
                return;
            }
            let layerSource = source || (type === 'WMTS' ?
                this.getWMTS({ url, params, sourceOptions })
                : new ol.source.XYZ({
                    url,
                    ...sourceOptions,
                })
            )
            const layer = new ol.layer.Tile({
                source: layerSource
            });

            // 将图层添加到地图上
            this.state.gis.addLayer(layer);
            this.olLayers.push({
                address: url,
                layer
            });
        }
    }
    // 添加超图图层
    addSuperMapLayer(url) {
        const exist = this.olLayers.find(item => item.address === url);
        if (exist) {
            exist.layer.setVisible(true);
            return;
        }

        const layer = new ol.layer.Tile({
            source: new ol.source.TileSuperMapRest({
                url
            })
        });
        // 将图层添加到地图上
        this.state.gis.addLayer(layer);
        this.olLayers.push({
            address: url,
            layer
        });
    }
    // 添加geoServer_geoJSON图层
    addGeoServerLayer(url) {
        const exist = this.olLayers.find(item => item.address === url);
        if (exist) {
            exist.layer.setVisible(true);
            return;
        }

        // 矢量数据源
        const vectorSource = new ol.source.Vector({
            // 设置格式化类型
            format: new ol.format.GeoJSON(),

            // url(extent) 在地图范围变化时调用，返回当前的地图范围
            url: function (extent) {
                return `${url}&bbox=${extent.join(',')}`;
            },
            strategy: ol.loadingstrategy.bbox,
        });

        // 矢量图层
        const layer = new ol.layer.Vector({
            // 设置数据源
            source: vectorSource,
            // 设置图层样式也可以 function (feature) { /** 根据内容动态加载样式 **/ return Style}
            style: function (feature) {
                const el = feature.A || {};
                const icon = JSON.parse(el.icon || '[]');
                let mapIcon = icon[0]?.id
                    ? `/cloudFile/common/downloadFile?id=${icon[0].id}`
                    : require("../images/defaultMarker.png");
                return new ol.style.Style({
                    // 点位图标
                    image: new ol.style.Icon({
                        scale: 1,
                        src: mapIcon,
                    }),
                    // 线样式
                    stroke: new ol.style.Stroke({
                        color: el.color || '#1890ff',
                        width: 4
                    }),
                    // 面样式
                    fill: new ol.style.Fill({
                        color: el.color || 'rgba(255,255,255, 0.5)'
                    })
                })
            },
        });
        // 将图层添加到地图上
        this.state.gis.addLayer(layer);
        this.olLayers.push({
            address: url,
            layer
        });
    }
    formatUrl(url) {
        let param = {}, address = url.split("?")[0];
        url.split("?")[1].split("&").map(item => {
            let json = item.split("=")
            param[json[0].toUpperCase()] = json[1] ? decodeURIComponent(json[1]) : '';
        })
        return { param, address }
    }
    // 添加geoServer_image图层
    addGeoServerImageLayer(item) {
        let url = item.coverage;
        const exist = this.olLayers.find(item => item.address === url);
        if (exist) {
            exist.layer.setVisible(true);
            return;
        }
        let { param = {}, address } = this.formatUrl(url);
        // 矢量数据源
        const vectorSource = new ol.source.ImageWMS({
            url: address,
            serverType: 'geoserver',
            crossOrigin: '*',
            ratio: 1,
            params: {
                VERSION: '1.1.0',
                ...(item.param || {}),
                ...param,
            },
        });

        // 矢量图层
        const layer = new ol.layer.Image({
            // 设置数据源
            source: vectorSource,
        });
        // 将图层添加到地图上
        this.state.gis.addLayer(layer);
        this.olLayers.push({
            address: url,
            layer,
            source: vectorSource
        });
    }
    // 初始化对外方法
    initPropsForUser() {
        const t = this;
        t.state.gis["getCenter"] = () => {
            return t.getCenter();
        }
        t.state.gis["setCenter"] = (gt) => {
            t.setCenter(gt);
        }
        t.state.gis["getZoomLevel"] = () => {
            return t.getZoomLevel();
        }
        t.state.gis["showInfoWindow"] = (obj) => {
            return t.showInfoWindow(obj);
        }
        t.state.gis["hideInfoWindow"] = () => {
            return t.hideInfoWindow();
        }
        t.state.gis["refresh"] = () => {
            t.refresh();
        }
    }
    // 设置中心点
    setCenter(gt) {
        let t = this;
        if (gt) {
            //经纬度 必须存在 否则不操作
            if (!gt[0] || !gt[1]) {
                return false;
            }
            //如果设置的经纬度 与当前中心点一样 不操作
            let c = t.getCenter();
            if (c.lng == gt[0] && c.lat == gt[1]) {
                return false;
            }
            t.state.gis.getView().setCenter(gt);
            t.viewer.animate({
                center: gt,
                duration: 2000,
            });
        }
    }
    //设置地图缩放层级
    setZoomLevel(zoom) {
        let t = this;
        let z = t.state.gis.getView().getZoom();
        if (z == zoom) {
            return false;
        }
        t.state.gis.getView().setZoom(zoom)
    }
    //获取当前中心点
    getCenter() {
        let t = this;
        const { gis } = t.state;
        let [xmin, ymin, xmax, ymax] = gis.getView().calculateExtent(gis.getSize());
        return { lng: (xmin + xmax) / 2, lat: (ymin + ymax) / 2 };
    }
    //编辑图元
    doEdit(id) {
        let t = this;
        //获取图元对象
        let gc = t.GM.getGraphic(id);
        let gp = t.GM.getGraphicParam(id);
        if (!gc) return false;
        //关闭先前编辑的图元
        if (!!t.state.editId) {
            t.endEdit();
        }
        if (!t.editToolbar) {
            t.editToolbar = new ol.interaction.Modify({
                source: gp.source,
            });
            t.state.gis.addInteraction(t.editToolbar)
            t.editToolbar.on('modifyend', function (e) {
                let feature = gc;
                e.features.forEach(function (feature) {
                    feature = feature
                })
                //返回参数
                let param = {
                    id,
                    e,
                };
                // 绘制内部管理的图元
                if (gp.geometry.type == 'point') {
                    let cur = feature.getProperties().geometry;
                    const [lng, lat] = cur.flatCoordinates;
                    //处理点返回参数
                    param = {
                        ...param,
                        attributes: {
                            ...gp.attributes,
                            longitude: lng,
                            latitude: lat,
                            other: {
                                ...gp.attributes,
                                longitude: lng,
                                latitude: lat,
                            }
                        },
                        param: {
                            attributes: {
                                ...gp.attributes,
                                longitude: lng,
                                latitude: lat,
                                other: {
                                    ...gp.attributes,
                                    longitude: lng,
                                    latitude: lat,
                                }
                            },
                            geometryType: gp.geometry.type,
                            mapLayer: t.GM.getGraphic(id)
                        },
                        geometryType: gp.geometry.type,
                        geometry: {
                            type: 'point',
                            x: lng,
                            y: lat,
                        },
                    }
                }
                //线
                if (gp.geometry.type == 'polyline') {
                    let cur = feature.getProperties().geometry;
                    let oddList = [], evenList = [];
                    cur.flatCoordinates.map((item, index) => {
                        // 判断下标奇偶数
                        if (index % 2 === 0) {
                            evenList.push(item)
                        } else {
                            oddList.push(item)
                        }
                    })
                    let path = oddList.map((item, index) => {
                        return [evenList[index], oddList[index]]
                    })
                    //处理线返回参数
                    let { lnglatAry, _extent } = t.dealData(path);
                    param = {
                        ...param,
                        attributes: {
                            ...gp.attributes,
                            paths: path,
                            other: {
                                ...gp.attributes,
                                paths: path,
                            }
                        },
                        param: {
                            attributes: {
                                ...gp.attributes,
                                paths: path,
                                other: {
                                    ...gp.attributes,
                                    paths: path,
                                }
                            },
                            geometry: {
                                paths: path,
                                _extent,
                                type: "polyline",
                            },
                            geometryType: 'polyline',
                            lnglatAry,
                            mapLayer: t.GM.getGraphic(id)
                        },
                        geometryType: gp.geometry.type,
                        geometry: {
                            paths: path,
                            _extent,
                            type: "polyline",
                        },
                        distance: t.calculateDistance(path),
                    }
                }
                //面
                if (gp.geometry.type == 'polygon') {
                    let cur = feature.getProperties().geometry;
                    let oddList = [], evenList = [];
                    cur.flatCoordinates.map((item, index) => {
                        // 判断下标奇偶数
                        if (index % 2 === 0) {
                            evenList.push(item)
                        } else {
                            oddList.push(item)
                        }
                    })
                    let path = oddList.map((item, index) => {
                        return [evenList[index], oddList[index]]
                    })
                    //处理线返回参数
                    let { lnglatAry, _extent } = t.dealData(path);
                    param = {
                        ...param,
                        attributes: {
                            ...gp.attributes,
                            rings: path,
                            other: {
                                ...gp.attributes,
                                paths: path,
                            }
                        },
                        param: {
                            attributes: {
                                ...gp.attributes,
                                rings: path,
                                other: {
                                    ...gp.attributes,
                                    paths: path,
                                }
                            },
                            geometry: {
                                rings: path,
                                type: 'polygon',
                                _extent
                            },
                            geometryType: 'polygon',
                            lnglatAry,
                            mapLayer: t.GM.getGraphic(id)
                        },
                        geometryType: gp.geometry.type,
                        geometry: {
                            rings: path,
                            type: 'polygon',
                            _extent
                        },
                        area: getPolygonArea(path),
                    }
                }
                if (gp.geometry.type == 'circle') {
                    let cur = feature.getProperties().geometry;
                    let center = cur.getCenter();
                    let sketchCoords_ = [cur.flatCoordinates[0], cur.flatCoordinates[1]];
                    let sketchCoords_2 = [cur.flatCoordinates[2], cur.flatCoordinates[3]];
                    let radius = ol.sphere.getDistance(sketchCoords_, sketchCoords_2);
                    param = {
                        ...param,
                        attributes: {
                            ...gp.attributes,
                            longitude: center[0],
                            latitude: center[1],
                            radius,
                            other: {
                                ...gp.attributes,
                                longitude: center[0],
                                latitude: center[1],
                                radius,
                            }
                        },
                        param: {
                            attributes: {
                                ...gp.attributes,
                                longitude: center[0],
                                latitude: center[1],
                                radius,
                                other: {
                                    ...gp.attributes,
                                    longitude: center[0],
                                    latitude: center[1],
                                    radius,
                                }
                            },
                            geometry: {
                                x: center[0],
                                y: center[1],
                                radius,
                                type: 'circle',
                            },
                            geometryType: 'circle',
                            mapLayer: t.GM.getGraphic(id)
                        },
                        geometryType: gp.geometry.type,
                        area: Math.PI * Math.pow(radius, 2),
                        geometry: {
                            type: 'circle',
                            x: center[0],
                            y: center[1],
                            radius
                        }
                    }
                }
                if ('editGraphicChange' in t.props && typeof (t.props.editGraphicChange) == 'function') {
                    t.props.editGraphicChange(param);
                }
                t.GM.setGraphic(id, feature)
                    .setGraphicParam(id, { ...param, source: gp.source });
            })
        }
        t.editId = id;
    }
    //关闭编辑
    endEdit() {
        let t = this;
        if (t.editToolbar) {
            t.state.gis.removeInteraction(t.editToolbar);
            t.editToolbar = null;
        }
        t.editId = '';
    }
    // 绘制图元
    draw(obj) {
        let t = this;
        const { drawInfo } = t;
        const { gis } = t.state;
        let drawParam = {}, image, stroke, fill;
        //初始化参数
        drawParam.geometryType = obj.geometryType || 'point';
        drawParam.parameter = obj.parameter ? { ...obj.parameter } : {};
        drawParam.data = obj.data ? { ...obj.data } : {};
        drawParam.data.id = (obj.data || {}).id || `draw${new Date().getTime()}`;
        //缓存 绘制的数据
        t.drawParam = drawParam;
        //判断id是否存在
        let len = t.state.drawIds[drawParam.geometryType].indexOf(drawParam.data.id);
        if (len > -1) {
            //如果id存在 删除存在的图元,清除drawId中的id数据
            t.removeGraphic(drawParam.data.id);
            t.state.drawIds[drawParam.geometryType].splice(len, 1);
        }
        let type = 'Point', style = new ol.style.Style({
            image: new ol.style.Icon({
                anchor: [-drawParam.parameter.markerContentX || -15, -drawParam.parameter.markerContentY || -15],
                anchorXUnits: 'pixels',
                anchorYUnits: 'pixels',
                src: drawParam.parameter.url || require("../images/defaultMarker.png"),
                opacity: 1,
                scale: drawParam.parameter.scale || 1,
            })
        });
        let geometryFunction;
        switch (drawParam.geometryType) {
            case 'point':
                type = 'Point';
                style = new ol.style.Style({
                    image: new ol.style.Icon({
                        anchor: [-drawParam.parameter.markerContentX || -15, -drawParam.parameter.markerContentY || -15],
                        anchorXUnits: 'pixels',
                        anchorYUnits: 'pixels',
                        src: drawParam.parameter.url || require("../images/defaultMarker.png"),
                        opacity: 1,
                        scale: drawParam.parameter.scale || 1,
                    })
                })
                break;
            case 'polyline':
                type = 'LineString';
                style = new ol.style.Style({
                    stoke: new ol.style.Stroke({
                        color: drawParam.parameter.color || '#277ffa',
                        width: drawParam.parameter.lineWidth || 3,
                        lineDash: drawParam.parameter.lineType == 'dashed' ? [2] : undefined,
                    })
                })
                break;
            case 'polygon':
                type = 'Polygon';
                style = new ol.style.Style({
                    stoke: new ol.style.Stroke({
                        color: drawParam.parameter.color || '#277ffa',
                        width: drawParam.parameter.lineWidth || 3,
                        lineDash: drawParam.parameter.lineType == 'dashed' ? [2] : undefined,
                    }),
                    fill: new ol.style.Fill({
                        color: drawParam.parameter.pellucidity ?
                            getRgbColor(drawParam.parameter.color || '#277ffa', drawParam.parameter.pellucidity) :
                            drawParam.parameter.color || '#277ffa',
                    })
                })
                break;
            case 'rectangle':
                type = 'Circle';
                geometryFunction = ol.interaction.Draw.createBox();
                break;
            case 'circle':
                type = 'Circle';
                style = new ol.style.Style({
                    stoke: new ol.style.Stroke({
                        color: drawParam.parameter.color || '#277ffa',
                        width: drawParam.parameter.lineWidth || 3,
                        lineDash: drawParam.parameter.lineType == 'dashed' ? [2] : undefined,
                    }),
                    fill: new ol.style.Fill({
                        color: drawParam.parameter.pellucidity ?
                            getRgbColor(drawParam.parameter.color || '#277ffa', drawParam.parameter.pellucidity) :
                            drawParam.parameter.color || '#277ffa',
                    })
                })
                break;
        }
        if (!t.drawToolbar) {
            t.drawToolbar = new ol.interaction.Draw({
                source: t.drawSource,
                type: type,
                geometryFunction: geometryFunction
                // style: style
            });
            gis.addInteraction(t.drawToolbar);
            t.drawToolbar.on('drawend', function (e) {
                // 关闭绘制事件
                t.drawToolbar.finishDrawing();
                // 移除
                gis.removeInteraction(t.drawToolbar)
                let gc = e.feature.getGeometry();
                //返回参数
                let param = {};
                // 绘制内部管理的图元
                if (t.drawParam.geometryType == 'point') {
                    const [lng, lat] = gc.flatCoordinates;
                    gc.x = lng;
                    gc.y = lat;
                    t.addPoint([{
                        id: t.drawParam.data.id,
                        longitude: lng,
                        latitude: lat,
                        url: t.drawParam.parameter.url || require("../images/defaultMarker.png"),
                        config: {
                            ...t.drawParam.parameter
                        }
                    }], 'point');
                    //处理点返回参数
                    param = {
                        id: t.drawParam.data.id,
                        attributes: {
                            id: t.drawParam.data.id,
                            url: t.drawParam.parameter.url || require("../images/defaultMarker.png"),
                            config: {
                                width: t.drawParam.parameter.width || 30,
                                height: t.drawParam.parameter.height || 30
                            }
                        },
                        geometry: gc,
                        geometryType: 'point',
                        mapLayer: t.GM.getGraphic(t.drawParam.data.id)
                    }
                }
                //线
                if (t.drawParam.geometryType == 'polyline') {
                    let oddList = [], evenList = [];
                    gc.flatCoordinates.map((item, index) => {
                        // 判断下标奇偶数
                        if (index % 2 === 0) {
                            evenList.push(item)
                        } else {
                            oddList.push(item)
                        }
                    })
                    let path = oddList.map((item, index) => {
                        return [evenList[index], oddList[index]]
                    })
                    t.addLine([{
                        id: t.drawParam.data.id,
                        paths: path,
                        config: {
                            ...t.drawParam.parameter
                        }
                    }], 'polyline');
                    //处理线返回参数
                    let { lnglatAry, _extent } = t.dealData(path);
                    param = {
                        lnglatAry,
                        id: t.drawParam.data.id,
                        geometry: {
                            ...e.geometry,
                            paths: path,
                            _extent
                        },
                        attributes: {
                            id: t.drawParam.data.id,
                            config: {
                                ...t.drawParam.parameter
                            }
                        },
                        distance: t.calculateDistance(path),
                        geometryType: 'polyline',
                        mapLayer: t.GM.getGraphic(t.drawParam.data.id)
                    }
                }
                //面
                if (t.drawParam.geometryType == 'polygon') {
                    let oddList = [], evenList = [];
                    gc.flatCoordinates.map((item, index) => {
                        // 判断下标奇偶数
                        if (index % 2 === 0) {
                            evenList.push(item)
                        } else {
                            oddList.push(item)
                        }
                    })
                    let path = oddList.map((item, index) => {
                        return [evenList[index], oddList[index]]
                    })
                    t.addPolygon([{
                        id: t.drawParam.data.id,
                        rings: path,
                        config: {
                            ...t.drawParam.parameter
                        }
                    }], t.drawParam.geometryType);
                    //处理线返回参数
                    let { lnglatAry, _extent } = t.dealData(path);
                    param = {
                        lnglatAry,
                        id: t.drawParam.data.id,
                        geometry: {
                            ...e.geometry,
                            rings: path,
                            type: t.drawParam.geometryType,
                            _extent
                        },
                        attributes: {
                            id: t.drawParam.data.id,
                            config: {
                                ...t.drawParam.parameter
                            }
                        },
                        area: getPolygonArea(path),
                        geometryType: t.drawParam.geometryType,
                        mapLayer: t.GM.getGraphic(t.drawParam.data.id)
                    }
                }
                if (t.drawParam.geometryType == 'rectangle') {
                    let path = e.feature.getGeometry().getCoordinates()[0];
                    t.addPolygon([{
                        id: t.drawParam.data.id,
                        rings: path,
                        config: {
                            ...t.drawParam.parameter
                        }
                    }], t.drawParam.geometryType);
                    //处理线返回参数
                    let { lnglatAry, _extent } = t.dealData(path);
                    param = {
                        lnglatAry,
                        id: t.drawParam.data.id,
                        geometry: {
                            ...e.geometry,
                            rings: path,
                            type: t.drawParam.geometryType,
                            _extent
                        },
                        attributes: {
                            id: t.drawParam.data.id,
                            config: {
                                ...t.drawParam.parameter
                            }
                        },
                        area: getPolygonArea(path),
                        geometryType: t.drawParam.geometryType,
                        mapLayer: t.GM.getGraphic(t.drawParam.data.id)
                    }
                }
                if (t.drawParam.geometryType == 'circle') {
                    let center = e.feature.getGeometry().getCenter();
                    let cur = e.feature.getProperties().geometry;
                    let sketchCoords_ = [cur.flatCoordinates[0], cur.flatCoordinates[1]];
                    let sketchCoords_2 = [cur.flatCoordinates[2], cur.flatCoordinates[3]];
                    let radius = ol.sphere.getDistance(sketchCoords_, sketchCoords_2);
                    t.addCircle([{
                        id: t.drawParam.data.id,
                        longitude: center[0],
                        latitude: center[1],
                        radius: radius,
                        config: {
                            ...t.drawParam.parameter
                        }
                    }], t.drawParam.geometryType);
                    param = {
                        area: Math.PI * Math.pow(radius, 2),
                        attributes: {
                            id: t.drawParam.data.id,
                            config: {
                                ...t.drawParam.parameter
                            }
                        },
                        geometry: {
                            type: t.drawParam.geometryType,
                            x: center[0],
                            y: center[1],
                            radius
                        },
                        geometryType: t.drawParam.geometryType,
                        mapLayer: t.GM.getGraphic(t.drawParam.data.id)
                    }
                }
                if ('drawEnd' in t.props && typeof (t.props.drawEnd) == 'function') {
                    t.props.drawEnd(param);
                }
            });
        }
    }
    // 关闭绘制
    closeDraw() {
        let t = this;
        const { gis } = t.state;
        if (t.drawToolbar) {
            // 关闭绘制事件
            t.drawToolbar.finishDrawing();
            // 移除
            gis.removeInteraction(t.drawToolbar)
            t.drawToolbar = null;
            t.drawInfo = {
                sketch: null,
                listener: null,
            };
        }
    }
    /*工具方法*/
    vtxRangingTool() {
        let t = this;
        let source = new ol.source.Vector({});
        t.rangingInfo.drawLayer = new ol.layer.Vector({
            source: source,
            style: new ol.style.Style({
                fill: new ol.style.Fill({
                    color: 'rgba(255, 255, 255, 0.2)',
                }),
                stroke: new ol.style.Stroke({
                    color: '#ffcc33',
                    width: 4,
                }),
                image: new ol.style.Circle({
                    radius: 7,
                    fill: new ol.style.Fill({
                        color: '#ffcc33',
                    }),
                }),
            }),
        })
        t.rangingInfo.draw = new ol.interaction.Draw({
            source,
            type: 'LineString',
            style: new ol.style.Style({
                fill: new ol.style.Fill({
                    color: 'rgba(255, 255, 255, 0.2)',
                }),
                stroke: new ol.style.Stroke({
                    color: 'rgba(0, 0, 0, 0.5)',
                    lineDash: [10, 10],
                    width: 4,
                }),
                image: new ol.style.Circle({
                    radius: 5,
                    stroke: new ol.style.Stroke({
                        color: 'rgba(0, 0, 0, 0.7)',
                    }),
                    fill: new ol.style.Fill({
                        color: 'rgba(255, 255, 255, 0.2)',
                    }),
                }),
            }),
        });
        let obj = {};
        t.createHelpTooltip();
        t.createMeasureTooltip();
        t.createDeleteTooltip();
        t.state.gis.addLayer(t.rangingInfo.drawLayer);
        t.state.gis.addInteraction(t.rangingInfo.draw);
        // 开始监听绘制
        t.rangingInfo.draw.on('drawstart', (evt) => {
            t.rangingInfo.feature = evt.feature;
            let tooltipCoord = evt.coordinate;
            t.rangingInfo.listener = evt.feature.getGeometry().on('change', function (evt) {
                const geom = evt.target;
                const { flatCoordinates } = geom;
                const lngLats = [[flatCoordinates[0], flatCoordinates[1]], [flatCoordinates[2], flatCoordinates[3]]];
                let output = t.formatLength(geom);
                tooltipCoord = geom.getLastCoordinate();
                obj = {
                    distance: output,
                    lnglats: lngLats,
                }
                t.rangingInfo.measureTooltipElement.innerHTML = output;
                t.rangingInfo.measureTooltip.setPosition(tooltipCoord);
                t.rangingInfo.deleteToolTip.setPosition(tooltipCoord);
                t.rangingInfo.deleteToolTip.setOffset([20, 10]);
            });
        });
        // 双击绘制完成
        t.rangingInfo.draw.on('drawend', () => {
            t.rangingInfo.measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
            t.rangingInfo.measureTooltip.setOffset([0, -7]);
            t.rangingInfo.feature = null;
            t.rangingInfo.measureTooltipElement = null;
            // t.createMeasureTooltip();
            new ol.Observable.unByKey(t.rangingInfo.listener);
            t.state.gis.removeInteraction(t.rangingInfo.draw);
            if ('mapRangingTool' in t.props) {
                t.props.mapRangingTool(obj);
            }
        });
    }
    // 绘图时创建提示
    createHelpTooltip() {
        const t = this;
        if (t.rangingTool.helpTooltipElement) {
            t.rangingTool.helpTooltipElement.parentNode.removeChild(t.rangingTool.helpTooltipElement);
        }
        t.rangingTool.helpTooltipElement = document.createElement('div');
        t.rangingTool.helpTooltipElement.className = 'ol-tooltip hidden';
        t.rangingTool.helpTooltip = new ol.Overlay({
            element: t.rangingTool.helpTooltipElement,
            offset: [15, 0],
            positioning: 'center-left',
        });
        t.state.gis.addOverlay(t.rangingTool.helpTooltip);
    }
    // 工具画图提示
    createMeasureTooltip() {
        const t = this;
        if (t.rangingInfo.measureTooltipElement) {
            t.rangingInfo.measureTooltipElement.parentNode.removeChild(t.rangingInfo.measureTooltipElement);
        }
        t.rangingInfo.measureTooltipElement = document.createElement('div');
        t.rangingInfo.measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
        t.rangingInfo.measureTooltip = new ol.Overlay({
            element: t.rangingInfo.measureTooltipElement,
            offset: [0, -15],
            positioning: 'bottom-center',
            stopEvent: false,
            insertFirst: false,
        });
        t.state.gis.addOverlay(t.rangingInfo.measureTooltip);
    }
    // 创建删除提示
    createDeleteTooltip() {
        const t = this;
        if (t.rangingInfo.deleteToolTipElement) {
            t.rangingInfo.deleteToolTipElement.parentNode.removeChild(t.rangingInfo.deleteToolTipElement);
        }
        t.rangingInfo.deleteToolTipElement = document.createElement('div');
        t.rangingInfo.deleteToolTipElement.className = 'ol-tooltip-delete';
        t.rangingInfo.deleteToolTipElement.innerHTML = 'X';
        t.rangingInfo.deleteToolTipElement.addEventListener('click', function (e) {
            t.rangingInfo.measureTooltipElement = null;
            t.rangingInfo.helpTooltipElement = null;
            t.rangingInfo.deleteToolTipElement = null;
            t.state.gis.removeOverlay(t.rangingInfo.measureTooltip);
            t.state.gis.removeOverlay(t.rangingTool.helpTooltip);
            t.state.gis.removeOverlay(t.rangingInfo.deleteToolTip);
            new ol.Observable.unByKey(t.rangingInfo.listener);
            t.state.gis.removeInteraction(t.rangingInfo.draw);
            t.state.gis.removeLayer(t.rangingInfo.drawLayer);
        })
        t.rangingInfo.deleteToolTip = new ol.Overlay({
            element: t.rangingInfo.deleteToolTipElement,
            offset: [15, 15],
            positioning: 'bottom-center',
            stopEvent: false,
            insertFirst: true,
        });
        t.state.gis.addOverlay(t.rangingInfo.deleteToolTip);
    }

    formatLength(line) {
        const { flatCoordinates } = line
        // const length = new ol.sphere.getDistance([flatCoordinates[0], flatCoordinates[1]],[flatCoordinates[2], flatCoordinates[3]]);
        let paths = []
        for (let n = 0; n < flatCoordinates.length; n += 2) {
            paths.push([flatCoordinates[n], flatCoordinates[n + 1]])
        }
        let length = 0;
        if (paths.length >= 2)
            paths.map((item, index) => {
                if (index <= paths.length - 2) {
                    length += ol.sphere.getDistance(paths[index], paths[index + 1])
                }
            })
        let output = '';
        if (length > 100) {
            output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
        } else {
            output = Math.round(length * 100) / 100 + ' ' + 'm';
        }
        return output;
    };
    // 获取地图的当前位置状态信息
    getMapExtent() {
        let t = this;
        const { gis } = t.state;
        let obj = {};
        if (gis) {
            let nowBounds = gis.getView().calculateExtent(gis.getSize());
            obj.southWest = {
                lng: nowBounds[0],
                lat: nowBounds[1],
            };
            obj.northEast = {
                lng: nowBounds[2],
                lat: nowBounds[3],
            };
            obj.nowCenter = t.getCenter();
            obj.zoom = t.getZoomLevel();
            const [width, height] = gis.getSize();
            obj.mapSize = { width: width, height: height };
            obj.radius = ol.sphere.getDistance(
                [obj.nowCenter.lng, obj.nowCenter.lat],
                [obj.northEast.lng, obj.northEast.lat],
            );
            return obj;
        }
    }
    //将制定图元展示在视野内 (强制改变地图中心位置)
    /*
        参数arg格式如下1,2
        1.string   格式如:'1,a,2,3,4'
        2.数组 ['1','2']
    */
    setVisiblePoints(mapVisiblePoints) {
        let t = this;
        const { gis } = t.state;
        let arg = null;
        let type = mapVisiblePoints.type;
        let ary = [];//图元id集合
        let obj = [];//经纬度集合
        switch (mapVisiblePoints.fitView) {
            case 'point':
                arg = this.state.pointIds;
                break;
            case 'line':
                arg = this.state.lineIds;
                break;
            case 'polygon':
                arg = this.state.polygonIds;
                break;
            case 'circle':
                arg = this.state.circleIds;
                break;
            case 'all':
                arg = this.state.pointIds.concat(this.state.lineIds).concat(this.state.polygonIds).concat(this.state.circleIds);
                break;
            default:
                arg = mapVisiblePoints.fitView;
                break;
        }
        if (typeof (arg) === 'string') {
            ary = arg.split(',');
        } else if (arg instanceof Array) {
            ary = arg;
        }
        for (let i = 0; i < ary.length; i++) {
            let g = t.GM.getGraphicParam(ary[i]);
            if (g) {
                switch (g.geometry.type) {
                    case 'point':
                        obj.push([g.geometry.x, g.geometry.y]);
                    case 'circle':
                        obj.push([g.geometry.x, g.geometry.y]);
                        break;
                    case 'polyline':
                        obj = [...obj, ...g.geometry.paths];
                        break;
                    case 'polygon':
                        obj = [...obj, ...g.geometry.rings];
                        break;
                }
            }
        }
        if (obj.length > 0) {
            let displayRange = new ol.extent.boundingExtent(obj);
            gis.getView().fit(displayRange, gis.getSize());
        }
    }
    getFitView(ids) {
        let t = this;
        if (ids.length > 0) {
            let maxX = null, maxY = null, minX = null, minY = null;
            for (let i = 0; i < ids.length; i++) {
                let coord = t.GM.getGraphic(ids[i]);
                let boundsArry = coord.getGeometry().getExtent();
                if (minX === null) {
                    minX = boundsArry[0]
                    minY = boundsArry[1]
                    maxX = boundsArry[2]
                    maxY = boundsArry[3]
                } else {
                    minX = Math.min(boundsArry[0], minX)
                    minY = Math.min(boundsArry[1], minY)
                    maxX = Math.max(boundsArry[2], maxX)
                    maxY = Math.max(boundsArry[3], maxY)
                }
            }
            const bounds = [minX, minY, maxX, maxY];
            return bounds;
        }
    }
    /*功能方法*/
    //获取当前地图的中心位置
    getCurrentCenter() {
        let t = this;
        const { gis } = t.state;
        let extent = gis.getView().calculateExtent(gis.getSize());
        return [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
    }
    //获取当前比例尺
    getZoomLevel() {
        let t = this;
        return t.state.gis.getView().getZoom();
    }
    //获取图元数据
    getGraphic(id) {
        let t = this;
        if (!id) {
            return false;
        }
        let gp = t.GM.getGraphicParam(id);
        let gg = t.GM.getGraphic(id);
        if (!gg) {
            return false;
        }
        let p = {},
            pts = [],
            lng = 0,
            lat = 0;
        switch (gp.geometryType) {
            case 'point':
                lng = gp.geometry.x;
                lat = gp.geometry.y;
                p = {
                    ...gp,
                    mapLayer: gg,
                    geometry: {
                        ...gp.geometry,
                        x: lng,
                        y: lat,
                    },
                    attributes: {
                        ...gp.attributes,
                        longitude: lng,
                        latitude: lat,
                        other: {
                            ...gp.attributes.other,
                            longitude: lng,
                            latitude: lat,
                        },
                    },
                };
                break;
            case 'polyline':
                pts = gp.geometry.paths;
                p = {
                    ...gp,
                    mapLayer: gg,
                    geometry: {
                        ...gp.geometry,
                        paths: pts,
                    },
                    attributes: {
                        ...gp.attributes,
                        paths: pts,
                        other: {
                            ...gp.attributes.other,
                            paths: pts,
                        },
                    },
                };
                break;
            case 'polygon':
                pts = gp.geometry.rings;
                p = {
                    ...gp,
                    mapLayer: gg,
                    geometry: {
                        ...gp.geometry,
                        rings: pts,
                    },
                    attributes: {
                        ...gp.attributes,
                        rings: pts,
                        other: {
                            ...gp.attributes.other,
                            rings: pts,
                        },
                    },
                    area: getPolygonArea(pts),
                };
                break;
            case 'circle':
                lng = gp.geometry.x;
                lat = gp.geometry.y;
                let radius = gp.geometry.radius;
                p = {
                    ...gp,
                    mapLayer: gg,
                    geometry: {
                        ...gp.geometry,
                        x: lng,
                        y: lat,
                        radius,
                    },
                    attributes: {
                        ...gp.attributes,
                        longitude: lng,
                        latitude: lat,
                        radius,
                        other: {
                            ...gp.attributes.other,
                            longitude: lng,
                            latitude: lat,
                            radius,
                        },
                    },
                };
                break;
        }
        return p;
    }
    // 转换dom节点
    parseDom(domStr) {
        const domObj = document.createElement('div');
        domObj.innerHTML = domStr;
        return domObj.childNodes;
    }
    //添加海量点
    addPointCollection(data = []) {
        let t = this;
        data.map((item, index) => {
            let d = item || {};
            let points = (d.points || []).map((d, i) => {
                let p = t.state.gis.getPixelFromCoordinate([d.lng, d.lat]);
                return [p[0], p[1]];
            });
            let [width, height] = t.state.gis.getSize();
            let options = {
                size: d.size,
                shape: d.shape,
                color: d.color,
                width: width,
                height: height,
                mapId: t.props.mapId
            };
            let VotexpointCollection = new GMapLib.PointCollection(points, options);
            t.morepoints.push({
                id: d.id,
                value: VotexpointCollection
            });
            VotexpointCollection.draw();
        })
    }
    //更新海量点
    updatePointCollection(data = []) {
        let t = this;
        data.map((ds, ind) => {
            t.morepoints.map((item, index) => {
                if (item.id == ds.id) {
                    let points = (ds.points || []).map((d, i) => {
                        let p = t.state.gis.getPixelFromCoordinate([d.lng, d.lat]);
                        return [p[0], p[1]];
                    });
                    let [width, height] = t.state.gis.getSize();
                    let options = {
                        size: ds.size,
                        shape: ds.shape,
                        color: ds.color,
                        width: width,
                        height: height
                    };
                    item.value.reDraw(points, options);
                }
            })
        })
    }
    //删除海量点
    clearPointCollection(ids = []) {
        let t = this;
        ids.map((id, ind) => {
            t.morepoints.map(function (item, index) {
                if (id == item.id) {
                    item.value.clear();
                }
            });
        });
    }
    //删除全部海量点
    clearAllPointCollection() {
        let t = this;
        t.morepoints.map(function (item, index) {
            item.value.clear();
        });
    }
    /*
    * 添加信息窗口
    * params
    * @position: Array[longitude,latitude]
    * @content: String|HTML
    * @close: boolean
    */
    showInfoWindow(params = {}) {
        const t = this;
        if (t.popupWindow) {
            t.hideInfoWindow();
        }
        t.popupWindow = new Popup({
            map: t.state.gis,
            position: params.position,
            innerHTML: params.content,
            close: params.close
        });
        t.popupWindow.showPopup();
    }
    hideInfoWindow() {
        const t = this;
        if (t.popupWindow) {
            t.popupWindow.removePopup();
        }
        t.popupWindow = null;
    }
    // 添加点
    addPoint(mapPoints, type) {
        let t = this;
        let ps = [];
        let psids = [...t.state.pointIds];
        mapPoints.map((item, index) => {
            //如果id重复,直接跳过不执行.
            if (this.GM.isRepetition(item.id)) {
                console.warn(`加点id: ${item.id} 重复`);
                return false;
            }
            //点位数据不符合,直接跳过
            if (!item.longitude || !item.latitude) {
                console.warn(`点 经纬度 数据错误`);
                return false;
            }
            // 创建点位图元要素
            let feature = new ol.Feature({
                geometry: new ol.geom.Point([parseFloat(item.longitude), parseFloat(item.latitude)]),
                name: item.name,
                id: item.id,
                params: {
                    ...item,
                },
            });
            let cg = {
                width: 30,
                height: 30,
                labelContent: '',
                labelPixelX: 0,
                labelPixelY: 34,
                markerContentX: -13,
                markerContentY: -42,
                zIndex: 100,
                deg: 0,
                scale: 1,
            };
            //初始化默认数据
            if (item.config) {
                cg = { ...cg, ...item.config };
            }
            // 覆盖物样式参数
            let style, icon, txt;
            let myImage = new Image(cg.width, cg.height);

            if (!!item.markerContent) {
                let nodes = t.parseDom(item.markerContent)[0];
                // 自定义图层需要把事件加在dom上
                nodes.addEventListener("click", e => {
                    t.clickGraphic(item.id, {
                        ...e,
                        pixel: [e.clientX, e.clientY]
                    })
                })
                // 创建地图自定义覆盖物
                let pop = new ol.Overlay({
                    id: item.id,
                    position: [parseFloat(item.longitude), parseFloat(item.latitude)],
                    positioning: 'center-center',
                    element: nodes,
                    autoPanMargin: 20,
                    autoPan: true,
                    offset: [0, -20],
                    insertFirst: true,
                });
                t.state.gis.addOverlay(pop);
            } else {
                // item.url || require("../images/defaultMarker.png"),
                canvasDataURL(
                    item.url || require("../images/defaultMarker.png"),
                    { width: cg.width, height: cg.height },
                    function (base64) {
                        myImage.src = base64;
                    }
                )
                // 创建地图要素图标样式
                style = new ol.style.Style({
                    image: new ol.style.Icon({
                        anchor: [-cg.markerContentX, -cg.markerContentY],
                        anchorXUnits: 'pixels',
                        anchorYUnits: 'pixels',
                        img: myImage,
                        imgSize: [cg.width, cg.height],
                        opacity: cg.opacity,
                        scale: cg.scale || 1,
                    }),
                });
            }
            if (!!item.canShowLabel && item.canShowLabel) {
                let textStyle = {
                    textAlign: 'center', //对齐方式
                    textBaseline: 'middle', //文本基线
                    font: 'normal 12px 微软雅黑', //字体样式
                    text: cg.labelContent, //文本内容
                    offsetX: cg.labelPixelX, // x轴偏置
                    offsetY: cg.labelPixelY, // Y轴偏置
                    fill: new ol.style.Fill({
                        //填充样式
                        color: '#1890ff',
                    }),
                    backgroundFill: new ol.style.Fill({
                        // 填充背景
                        color: 'rgba(255, 255, 255, 1)',
                    }),
                    padding: [2, 5, 2, 5],
                    ...(cg.labelStyle || {})
                }
                if (cg.labelStyle && cg.labelStyle.fill) {
                    textStyle['fill'] = new ol.style.Fill({
                        color: cg.labelStyle.fill
                    })
                }
                if (cg.labelStyle && cg.labelStyle.backgroundFill) {
                    textStyle['backgroundFill'] = new ol.style.Fill({
                        color: cg.labelStyle.backgroundFill
                    })
                }
                // 创建地图要素图标样式
                style = new ol.style.Style({
                    image: new ol.style.Icon({
                        anchor: [-cg.markerContentX, -cg.markerContentY],
                        anchorXUnits: 'pixels',
                        anchorYUnits: 'pixels',
                        // src: item.url || require("../images/defaultMarker.png"),
                        img: myImage,
                        imgSize: [cg.width, cg.height],
                        opacity: cg.opacity,
                        scale: cg.scale || 1,
                    }),
                    // 创建地图要素文字样式
                    text: new ol.style.Text(textStyle),
                });
            }
            feature.setStyle(style);
            // 初始化适量数据源
            let source = new ol.source.Vector({
                features: [feature],
                name: 'point',
                id: item.id,
            });
            let pointLayer = new ol.layer.Vector({
                name: 'point',
                source,
                id: item.id,
            });
            t.pointLayers.push({
                id: item.id,
                layer: pointLayer
            })
            //添加点位图层
            t.state.gis.addLayer(pointLayer);
            if (!item.markerContent && cg.BAnimationType == 0) {
                marker.setAnimation(BMAP_ANIMATION_BOUNCE);
            } else if (!item.markerContent && cg.BAnimationType == 1) {
                marker.setAnimation(BMAP_ANIMATION_DROP);
            }
            psids.push(item.id);
            //缓存图元的数据,偏于后期操作
            this.GM.setGraphic(item.id, feature).setGraphicParam(item.id, {
                attributes: { ...item, other: item },
                geometryType: 'point',
                geometry: {
                    type: 'point',
                    x: parseFloat(item.longitude),
                    y: parseFloat(item.latitude),
                },
                source
            });
        });
        if (type !== 'defined') {
            // t.state.pointIds = psids;
            t.setState({
                pointIds: psids
            })
        }
    }
    //更新点
    updatePoint(mapPoints = []) {
        let t = this;
        mapPoints.map((item, index) => {
            //判断图元是否存在.
            if (this.GM.isRepetition(item.id)) {
                //点位数据不符合,直接跳过
                if (!item.longitude || !item.latitude) {
                    console.warn(`点 经纬度 数据错误`);
                    return false;
                }
                let gc = t.GM.getGraphic(item.id);
                let gp = t.GM.getGraphicParam(item.id);
                let cg = {
                    width: 30,
                    height: 30,
                    labelContent: '',
                    labelPixelX: 0,
                    labelPixelY: 34,
                    BAnimationType: 3,
                    //默认点的偏移值就不同
                    markerContentX: -15,
                    markerContentY: -30,
                    deg: 0,
                };
                if (item.config) {
                    cg = { ...cg, ...item.config };
                }

                let text, icon, marker;
                let myImage = new Image(cg.width, cg.height);
                if (item.markerContent) {
                    let overlay = t.state.gis.getOverlayById(item.id);
                    let nodes = t.parseDom(item.markerContent)[0];
                    nodes.addEventListener("click", e => {
                        t.clickGraphic(item.id, {
                            ...e,
                            pixel: [e.clientX, e.clientY]
                        })
                    })
                    overlay.setElement(nodes);
                    overlay.setPosition([parseFloat(item.longitude), parseFloat(item.latitude)]);
                    t.state.gis.changed();
                } else {
                    canvasDataURL(
                        item.url || require("../images/defaultMarker.png"),
                        { width: cg.width, height: cg.height },
                        function (base64) {
                            myImage.src = base64;
                        }
                    )
                    icon = new ol.style.Icon({
                        anchor: [-cg.markerContentX, -cg.markerContentY],
                        anchorXUnits: 'pixels',
                        anchorYUnits: 'pixels',
                        // src: item.url || require("../images/defaultMarker.png"),
                        img: myImage,
                        imgSize: [cg.width, cg.height],
                        opacity: cg.opacity,
                        scale: cg.scale || 1,
                        rotation: Math.PI / 180 * cg.deg,
                    })
                    if (item.canShowLabel) {
                        let textStyle = {
                            textAlign: 'center', //对齐方式
                            textBaseline: 'middle', //文本基线
                            font: 'normal 12px 微软雅黑', //字体样式
                            text: cg.labelContent, //文本内容
                            offsetX: cg.labelPixelX, // x轴偏置
                            offsetY: cg.labelPixelY, // Y轴偏置
                            fill: new ol.style.Fill({
                                //填充样式
                                color: '#1890ff',
                            }),
                            backgroundFill: new ol.style.Fill({
                                // 填充背景
                                color: 'rgba(255, 255, 255, 1)',
                            }),
                            padding: [2, 5, 2, 5],
                            ...(cg.labelStyle || {})
                        }
                        if (cg.labelStyle && cg.labelStyle.fill) {
                            textStyle['fill'] = new ol.style.Fill({
                                color: cg.labelStyle.fill
                            })
                        }
                        if (cg.labelStyle && cg.labelStyle.backgroundFill) {
                            textStyle['backgroundFill'] = new ol.style.Fill({
                                color: cg.labelStyle.backgroundFill
                            })
                        }
                        text = new ol.style.Text(textStyle)
                    }
                    if (text) {
                        gc.setStyle(new ol.style.Style({
                            image: icon,
                            text,
                        }))
                    } else {
                        gc.setStyle(new ol.style.Style({
                            image: icon,
                        }))
                    }
                }
                gc.setGeometry(new ol.geom.Point([parseFloat(item.longitude), parseFloat(item.latitude)]));
                this.GM.setGraphicParam(
                    item.id,
                    {
                        attributes: { ...item, other: item },
                        geometryType: 'point',
                        geometry: {
                            type: 'point',
                            x: parseFloat(item.longitude),
                            y: parseFloat(item.latitude)
                        },
                        source: gp.source
                    }
                );
            } else {
                console.warn(`更新的点位id不存在!`);
                return false;
            }
        });
        t.refresh();
    }
    // 更新图层
    refresh() {
        const t = this;
        let timer = setTimeout(() => {
            clearTimeout(timer);
            window.VtxMap[t.props.mapId].redrawText();
        }, 100)
    }
    // 添加先
    addLine(mapLines, type) {
        let t = this;
        let ls = [];
        let lsids = [...t.state.lineIds];
        //遍历添加线(图元)
        mapLines.map((item, index) => {
            //如果id重复,直接跳过不执行.
            if (this.GM.isRepetition(item.id)) {
                console.warn(`多折线id: ${item.id} 重复`);
                return false;
            }
            //多折线点位数据不符合,直接跳过
            if (!(item.paths && item.paths.length >= 2)) {
                console.warn(`多折线paths数据错误`);
                return false;
            }
            let cg = {
                color: '#277ffa',
                pellucidity: 0.9,
                lineWidth: 5,
                lineType: 'solid',
                isHidden: false,
            };
            if (item.config) {
                cg = { ...cg, ...item.config };
            }
            const style = new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: cg.color,
                    width: cg.lineWidth,
                    lineDash: cg.lineType == 'dashed' ? [2] : undefined,
                }),
            });
            let polyline = new ol.Feature({
                geometry: new ol.geom.LineString(item.paths),
                id: item.id,
                params: {
                    ...item,
                },
            });
            polyline.setStyle(style);
            let source = new ol.source.Vector({
                features: [polyline],
                name: 'polyline',
                id: item.id,
            })
            let lineLayer = new ol.layer.Vector({
                name: 'polyline',
                id: item.id,
                source,
            });
            t.state.gis.addLayer(lineLayer);
            //缓存图元的数据,便于后期操作
            let pts = item.paths.map((itt, ind) => {
                return [...itt];
            });
            this.GM.setGraphic(item.id, polyline).setGraphicParam(item.id, {
                attributes: {
                    ...item,
                    paths: pts,
                    other: item,
                },
                geometryType: 'polyline',
                geometry: {
                    type: 'polyline',
                    paths: pts,
                },
                source: source,
            });
            ls.push(polyline);
            lsids.push(item.id);
            t.state.lineIds.push(item.id);
        });
        if (type !== 'defined') {
            t.state.lineIds = lsids;
        }
    }
    //更新线
    updateLine(mapLines) {
        let t = this;
        //遍历添加线(图元)
        mapLines.map((item, index) => {
            //判断图元是否存在.
            if (this.GM.isRepetition(item.id)) {
                //多折线点位数据不符合,直接跳过
                if (!(item.paths && item.paths.length >= 2)) {
                    console.warn(`多折线paths数据错误`);
                    return false;
                }
                //初始化默认参数
                let cg = {
                    color: '#277ffa',
                    pellucidity: 0.9,
                    lineWidth: 5,
                    lineType: 'solid',//'solid'  'dashed'
                    isHidden: false
                }
                //获取原有的图元
                let gc = this.GM.getGraphic(item.id);
                let gp = this.GM.getGraphicParam(item.id);
                //重新初始化值
                if (item.config) {
                    cg = { ...cg, ...item.config };
                }
                let pts = item.paths.map((itt, ind) => {
                    return [...itt];
                });
                const style = new ol.style.Style({
                    stroke: new ol.style.Stroke({
                        color: cg.color,
                        width: cg.lineWidth,
                        lineDash: cg.lineType == 'dashed' ? [2] : undefined,
                        zIndex: cg.zIndex || 0,
                    }),
                });
                gc.setStyle(() => {
                    return style
                })
                gc.setGeometry(new ol.geom.LineString(pts));
                this.GM.setGraphicParam(item.id, {
                    attributes: {
                        ...item,
                        paths: pts,
                        other: item,
                    },
                    geometryType: 'polyline',
                    geometry: {
                        type: 'polyline',
                        paths: pts,
                    },
                    source: gp.source,
                });
            } else {
                console.warn(`更新的多折线id不存在!`);
                return false;
            }
        });
    }
    //添加面
    addPolygon(mapPolygons) {
        let t = this;
        let pgs = [];
        let pgsids = [...t.state.polygonIds];
        //遍历添加面(图元)
        mapPolygons.map((item, index) => {
            //如果id重复,直接跳过不执行.
            if (this.GM.isRepetition(item.id)) {
                console.warn(`多边形id: ${item.id} 重复`);
                return false;
            }
            //多边形点位数据不符合,直接跳过
            if (!(item.rings && item.rings.length >= 3)) {
                console.warn(`多边形rings数据错误`);
                return false;
            }
            let cg = {
                lineType: 'solid',
                lineWidth: 5,
                lineColor: '#277ffa',
                lineOpacity: 1,
                color: '#fff',
                pellucidity: 0.5,
            };
            if (item.config) {
                cg = { ...cg, ...item.config };
            }
            const style = new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: cg.lineColor,
                    width: cg.lineWidth,
                    lineDash: cg.lineType == 'dashed' ? [2] : undefined,
                }),
                fill: new ol.style.Fill({
                    color: cg.pellucidity ? getRgbColor(cg.color, cg.pellucidity) : cg.color,
                }),
            });
            let polygon = new ol.Feature({
                geometry: new ol.geom.Polygon([item.rings]),
                id: item.id,
                params: {
                    ...item,
                },
                name: 'polygon',
            });
            polygon.setStyle(style);
            let source = new ol.source.Vector({
                features: [polygon],
                id: item.id,
            })
            let polygonLayer = new ol.layer.Vector({
                name: 'polygon',
                id: item.id,
                source,
            });
            t.state.gis.addLayer(polygonLayer);
            //缓存图元的数据,便于后期操作
            let pts = item.rings.map((itt, ind) => {
                return [...itt];
            });
            this.GM.setGraphic(item.id, polygon).setGraphicParam(item.id, {
                attributes: {
                    ...item,
                    rings: pts,
                    other: item,
                },
                geometryType: 'polygon',
                geometry: {
                    type: 'polygon',
                    rings: pts,
                },
                source
            });
            pgs.push(polygon);
            pgsids.push(item.id);
        });
        t.state.polygonIds = pgsids;
    }
    //更新面
    updatePolygon(mapPolygons) {
        let t = this;
        mapPolygons.map((item, index) => {
            //判断图元是否存在.
            if (this.GM.isRepetition(item.id)) {
                //多边形点位数据不符合,直接跳过
                if (!(item.rings && item.rings.length >= 3)) {
                    console.warn(`多边形rings数据错误`);
                    return false;
                }
                //获取原有的图元
                let gc = this.GM.getGraphic(item.id);
                let gp = t.GM.getGraphicParam(item.id);
                //获取原有的面属性,转换key值
                let cg = {
                    lineType: 'solid',
                    lineWidth: 5,
                    lineColor: '#277ffa',
                    lineOpacity: 1,
                    color: '#fff',
                    pellucidity: 0.5
                };
                //重新初始化值
                if (item.config) {
                    cg = { ...cg, ...item.config };
                }
                let pts = item.rings.map((itt, ind) => {
                    return [...itt];
                });
                gc.setGeometry(new ol.geom.Polygon([pts]));
                gc.setStyle(new ol.style.Style({
                    stroke: new ol.style.Stroke({
                        color: cg.lineColor,
                        width: cg.lineWidth,
                        lineDash: cg.lineType == 'dashed' ? [2] : undefined,
                    }),
                    fill: new ol.style.Fill({
                        color: cg.pellucidity ? getRgbColor(cg.color, cg.pellucidity) : cg.color,
                    }),
                }))
                this.GM.setGraphicParam(item.id, {
                    attributes: {
                        ...item,
                        rings: pts,
                        other: item,
                    },
                    geometryType: 'polygon',
                    geometry: {
                        type: 'polygon',
                        rings: pts,
                    },
                    source: gp.source
                });
            } else {
                console.warn(`更新的多边形id不存在!`);
                return false;
            }
        });
    }
    //添加圆  circle
    addCircle(mapCircles, type) {
        let t = this;
        let ccsids = [...t.state.circleIds];
        if (type) {
            ccsids = [...t.state.drawIds[type]];
        }
        mapCircles.map((item, index) => {
            //如果id重复,直接跳过不执行.
            if (t.GM.isRepetition(item.id)) {
                console.warn(`圆id: ${item.id} 重复`);
                return false;
            }
            //圆 点位数据不符合,直接跳过
            if (!item.longitude || !item.latitude) {
                console.warn(`圆 经纬度 数据错误`);
                return false;
            }
            let cg = {
                lineType: 'solid',
                lineWidth: 5,
                lineColor: '#277ffa',
                lineOpacity: 1,
                color: '#fff',
                pellucidity: 0.5
                // isHidden: false  //后期需要在加
            }
            if (item.config) {
                cg = { ...cg, ...item.config };
            }
            const style = new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: cg.lineColor,
                    width: cg.lineWidth,
                    lineDash: cg.lineType == 'dashed' ? [2] : undefined,
                }),
                fill: new ol.style.Fill({
                    color: cg.pellucidity ? getRgbColor(cg.color, cg.pellucidity) : cg.color,
                }),
            });
            let metersPerUnit = t.state.gis.getView().getProjection().getMetersPerUnit();
            let circleRadius = item.radius / metersPerUnit;
            let circle = new ol.Feature({
                geometry: new ol.geom.Circle([item.longitude, item.latitude], parseFloat(circleRadius)),
                id: item.id,
                params: {
                    ...item,
                },
                name: 'circle'
            });
            circle.setStyle(style);
            let source = new ol.source.Vector({
                features: [circle],
                name: 'circle',
                id: item.id,
            });
            let circleLayer = new ol.layer.Vector({
                name: 'circle',
                id: item.id,
                source
            });
            t.state.gis.addLayer(circleLayer);
            ccsids.push(item.id);
            t.GM.setGraphic(item.id, circle)
                .setGraphicParam(item.id, {
                    attributes: { ...item, other: item },
                    geometryType: 'circle',
                    geometry: {
                        type: 'circle',
                        x: parseFloat(item.longitude),
                        y: parseFloat(item.latitude),
                        radius: parseFloat(item.radius)
                    },
                    source
                });
        });
        //添加绘制点
        if (type) {
            t.state.drawIds = {
                ...t.state.drawIds,
                [type]: ccsids
            }
        } else {
            t.state.circleIds = ccsids;
        }
    }
    //更新圆
    updateCircle(mapCircles) {
        let t = this;
        mapCircles.map((item, index) => {
            //判断图元是否存在.
            if (t.GM.isRepetition(item.id)) {
                //圆 点位数据不符合,直接跳过
                if (!item.longitude || !item.latitude) {
                    console.warn(`圆 经纬度 数据错误`);
                    return false;
                }
            } else {
                console.warn(`更新的圆id不存在!`);
                return false;
            }
            //获取原有的图元
            let gc = t.GM.getGraphic(item.id);
            let gp = t.GM.getGraphicParam(item.id);
            //获取原有的面属性,转换key值
            let cg = {
                lineType: 'solid',
                lineWidth: 5,
                lineColor: '#277ffa',
                lineOpacity: 1,
                color: '#fff',
                pellucidity: 0.5
                // isHidden: false  //后期需要在加
            }
            if (item.config) {
                cg = { ...cg, ...item.config };
            }
            let metersPerUnit = t.state.gis.getView().getProjection().getMetersPerUnit();
            let circleRadius = item.radius / metersPerUnit;
            gc.setGeometry(new ol.geom.Circle([item.longitude, item.latitude], parseFloat(circleRadius)));
            gc.setStyle(new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: cg.lineColor,
                    width: cg.lineWidth,
                    lineDash: cg.lineType == 'dashed' ? [2] : undefined,
                }),
                fill: new ol.style.Fill({
                    color: cg.pellucidity ? getRgbColor(cg.color, cg.pellucidity) : cg.color,
                }),
            }))
            t.GM.setGraphicParam(item.id, {
                attributes: { ...item, other: item },
                geometryType: 'circle',
                geometry: {
                    type: 'circle',
                    x: parseFloat(item.longitude),
                    y: parseFloat(item.latitude),
                    radius: parseFloat(item.radius)
                },
                source: gp.source,
            });
        });
        //刷新图元
    }
    // 工具方法
    //删除图元
    removeGraphic(id, type) {
        let t = this;
        let graphic = t.GM.getGraphic(id);
        let gp = t.GM.getGraphicParam(id);
        //刪除label
        if (t.Label[id]) {
            t.Label[id].html.remove();
            delete t.Label[id];
        }
        if (!!graphic) {
            //清除聚合点 避免异常
            // t._cluster.removeMarker(this.GM.getGraphic(id));
            //清除地图中图元
            // const layers = t.state.gis.getLayers().getArray();
            // const layer = layers.filter(item => item.getProperties().name == type)[0];
            gp.source.removeFeature(graphic);
            // layer && layer.getSource().removeFeature(graphic);
            //清除对应id的图元数据缓存
            t.GM.removeGraphic(id);
            t.GM.removeGraphicParam(id);
            if (t.state.gis.getOverlayById(id)) {
                t.state.gis.removeOverlay(t.state.gis.getOverlayById(id))
            }
        } else {
            return false;
        }
        for (let i = 0; i < t.movePoints.length; i++) {
            if (t.movePoints[i].id == id) {
                t.movePoints.splice(i, 1);
                continue;
            }
        }
        let ids = [];
        switch (type) {
            case 'point':
                ids = t.state.pointIds;
                break;
            case 'line':
                ids = t.state.lineIds;
                break;
            case 'polygon':
                ids = t.state.polygonIds;
                break;
            case 'circle':
                ids = t.state.circleIds;
                break;
            case 'draw':
                if (t.state.drawIds.point.indexOf(id) > -1) {
                    t.state.drawIds.point.splice(t.state.drawIds.point.indexOf(id), 1);
                }
                if (t.state.drawIds.polyline.indexOf(id) > -1) {
                    t.state.drawIds.polyline.splice(t.state.drawIds.polyline.indexOf(id), 1);
                }
                if (t.state.drawIds.polygon.indexOf(id) > -1) {
                    t.state.drawIds.polygon.splice(t.state.drawIds.polygon.indexOf(id), 1);
                }
                if (t.state.drawIds.circle.indexOf(id) > -1) {
                    t.state.drawIds.circle.splice(t.state.drawIds.circle.indexOf(id), 1);
                }
                if (t.state.drawIds.rectangle.indexOf(id) > -1) {
                    t.state.drawIds.rectangle.splice(t.state.drawIds.rectangle.indexOf(id), 1);
                }
                break;
            default:
                if (t.state.pointIds.indexOf(id) > -1) {
                    t.state.pointIds.splice(t.state.pointIds.indexOf(id), 1);
                }
                if (t.state.lineIds.indexOf(id) > -1) {
                    t.state.lineIds.splice(t.state.lineIds.indexOf(id), 1);
                }
                if (t.state.polygonIds.indexOf(id) > -1) {
                    t.state.polygonIds.splice(t.state.polygonIds.indexOf(id), 1);
                }
                if (t.state.circleIds.indexOf(id) > -1) {
                    t.state.circleIds.splice(t.state.circleIds.indexOf(id), 1);
                }
                break;
        }
        if (id == t.state.editId) {
            t.state.editId = '';
        }
        if (ids.indexOf(id) != -1) {
            ids.splice(ids.indexOf(id), 1);
        }
    }
    //清空地图
    clearAll() {
        let t = this;
        const { gis } = t.state;
        const layers = gis.getLayers();
        //清空热力图
        if (t.heatmap) {
            let hMap = layers.filter(item => item.name == 'heatMap')[0];
            hMap.getSource().clear();
            gis.removeLayer(layer);
        }
        t.heatmap = null;
        t.movePoints = [];

        t.state.pointIds = [];
        t.pointLayers.map(item => {
            gis.removeLayer(item.layer)
            t.pointLayers = [];
        })

        t.clearAllPointCollection();
        t.closeDraw();
        if (t.clusterInfo.clusterHulls || t.clusterInfo.clusters || t.clusterInfo.clusterCircles) {
            t.clusterHulls.getSource().clear();
            t.clusterInfo.clusterSource = null;
            gis.removeLayer(t.clusterInfo.clusterHulls);
            gis.removeLayer(t.clusterInfo.clusters);
            gis.removeLayer(t.clusterInfo.clusterCircles);
            t.clusterInfo.clusterHulls = null;
            t.clusterInfo.clusters = null;
            t.clusterInfo.clusterCircles = null;
        }
        //清空缓存数据
        t.GM.clearAll();
        //循环所有id删除
        let { pointIds, lineIds, polygonIds, circleIds, drawIds } = t.state;
        //拷贝数组,避免原数组操作,影响循环
        let ps = [...pointIds],
            ls = [...lineIds],
            pgs = [...polygonIds],
            cs = [...circleIds];
        // 删除点
        for (let i = 0; i < ps.length; i++) {
            t.removeGraphic(ps[i], 'point');
        }
        // 删除线
        for (let i = 0; i < ls.length; i++) {
            t.removeGraphic(ls[i], 'line');
        }
        // 删除面
        for (let i = 0; i < pgs.length; i++) {
            t.removeGraphic(pgs[i], 'polygon');
        }
        // 删除圆
        for (let i = 0; i < cs.length; i++) {
            t.removeGraphic(cs[i], 'circle');
        }
        //删除绘制的点
        let { point, polyline, polygon, circle, rectangle } = drawIds;
        for (let i = 0; i < point.length; i++) {
            t.removeGraphic(point[i]);
        }
        for (let i = 0; i < polyline.length; i++) {
            t.removeGraphic(polyline[i]);
        }
        for (let i = 0; i < polygon.length; i++) {
            t.removeGraphic(polygon[i]);
        }
        for (let i = 0; i < circle.length; i++) {
            t.removeGraphic(circle[i]);
        }
        for (let i = 0; i < rectangle.length; i++) {
            t.removeGraphic(rectangle[i]);
        }
    }
    //展示比例尺
    showControl(props) {
        let t = this;
        const { gis } = t.state;
        const config = props.showControl;
        if (t.scaleControl) {
            gis.removeControl(t.scaleControl);
        }
        t.scaleControl = new ol.control.ScaleLine({
            units: 'metric',
            //设置度量单位
            className: `ol-scale-line-${config.location}`
        });
        gis.addControl(t.scaleControl);
        setTimeout(function () {
            if (config.location == 'tl') {
                $(`div.ol-scale-line-${config.location}`).css({
                    position: 'absolute',
                    left: config.offset ? config.offset[0] : 0 + 65,
                    top: config.offset ? config.offset[1] : 0,
                    textAlign: 'center',
                })
            } else if (config.location == 'bl') {
                $(`div.ol-scale-line-${config.location}`).css({
                    position: 'absolute',
                    left: config.offset ? config.offset[0] : 0 + 65,
                    bottom: config.offset ? config.offset[1] : 0,
                    textAlign: 'center',
                })
            } else if (config.location == 'tr') {
                $(`div.ol-scale-line-${config.location}`).css({
                    position: 'absolute',
                    right: config.offset ? config.offset[0] : 0 + 65,
                    top: config.offset ? config.offset[1] : 0,
                    textAlign: 'center',
                })
            } else if (config.location == 'br') {
                $(`div.ol-scale-line-${config.location}`).css({
                    position: 'absolute',
                    right: config.offset ? config.offset[0] : 0 + 65,
                    bottom: config.offset ? config.offset[1] : 0,
                    textAlign: 'center',
                })
            }
        }, 20)
    }
    //设置区域限制
    setAreaRestriction(areaRestriction) {
        let t = this;
        let { _extent: _et } = t.dealData(areaRestriction);
        t.areaRestriction = t.state.gis.getView().setProperties({
            extent: [_et.xmax, _et.ymax, _et.xmin, _et.ymin],
        }, false);
    }
    //关闭区域限制
    clearAreaRestriction() {
        let t = this;
        t.areaRestriction = null;
    }
    //区域限制逻辑
    dealAreaRestriction(e) {
        let t = this;
        //如果在区域内,不处理
        if (t.areaRestriction.contains(e.extent.getCenter())) {
            return;
        }
        // if(t.containsExtent(t.areaRestriction,e.extent)){
        //    return;
        // }
        let { xmin: xmin1, xmax: xmax1, ymin: ymin1, ymax: ymax1 } = t.areaRestriction;
        let { xmin: xmin2, xmax: xmax2, ymin: ymin2, ymax: ymax2 } = e.extent;
        let x = e.extent.getCenter().x,
            y = e.extent.getCenter().y;
        if (x < xmin1) x = xmin1 + 0.1;
        if (x > xmax1) x = xmax1 - 0.1;
        if (y < ymin1) y = ymin1 + 0.1;
        if (y > ymax1) y = ymax1 - 0.1;
        t.state.gis.getView().setCenter([x, y]);
    }
    //聚合地图图元(arg为空时聚合全部点)
    cluster(arg) {
        let t = this;
        let ary = [];
        if (!arg) {
            let { pointIds } = t.state;
            ary = pointIds;
        } else {
            if (Object.prototype.toString.apply(arg) === '[object Array]') {
                ary = arg;
            } else if (typeof arg === 'string') {
                ary = arg.split(',');
            }
        }
        t.state.pointIds = [];
        t.pointLayers.map(item => {
            t.state.gis.removeLayer(item.layer);
            t.pointLayers = [];
        })
        let ms = this.GM.getMoreGraphic(ary).filter((item, index) => {
            // return !item && item != 0 ? false : true;
            return item && item.getGeometry().getType() === 'Point' && !item.label;
        });
        const source = new ol.source.Vector({
            features: ms
        })
        t.clusterInfo.clusterSource = new ol.source.Cluster({
            distance: 80,
            minDistance: 0,
            source,
        });
        t.clusterInfo.clusterHulls = new ol.layer.Vector({
            source: t.clusterInfo.clusterSource,
            style: clusterHullStyle,
        });
        t.state.gis.addLayer(t.clusterInfo.clusterHulls);
        t.clusterInfo.clusters = new ol.layer.Vector({
            source: t.clusterInfo.clusterSource,
            style: clusterStyle,
        });
        t.state.gis.addLayer(t.clusterInfo.clusters);
        t.clusterInfo.clusterCircles = new ol.layer.Vector({
            source: t.clusterInfo.clusterSource,
            style: clusterCircleStyle,
        });
        t.state.gis.addLayer(t.clusterInfo.clusterCircles);
        function clusterMemberStyle(clusterMember) {
            let style = clusterMember.getStyle();
            let image = style && style.getImage ? style.getImage() : null;
            return new ol.style.Style({
                geometry: clusterMember.getGeometry(),
                image: image
            });
        }
        function clusterCircleStyle(cluster, resolution) {
            if (cluster !== t.clusterInfo.clickFeature || resolution !== t.clusterInfo.clickResolution) {
                return;
            }
            const clusterMembers = cluster.get('features');
            const centerCoordinates = cluster.getGeometry().getCoordinates();
            return generatePointsCircle(
                clusterMembers.length,
                cluster.getGeometry().getCoordinates(),
                resolution,
            ).reduce((styles, coordinates, i) => {
                const point = new ol.geom.Point(coordinates);
                const line = new ol.geom.LineString([centerCoordinates, coordinates]);
                styles.unshift(
                    new ol.style.Style({
                        geometry: line,
                        stroke: new ol.style.Stroke({
                            color: 'rgba(204, 85, 0, 1)',
                            width: 1.5,
                        }),
                    }),
                );
                styles.push(
                    clusterMemberStyle(
                        new ol.Feature({
                            ...clusterMembers[i].getProperties(),
                            geometry: point,
                        }),
                    ),
                );
                return styles;
            }, []);
        }
        function generatePointsCircle(count, clusterCenter, resolution) {
            const circumference = 1 * 28 * (2 + count);
            let legLength = circumference / (Math.PI * 2); //radius from circumference
            const angleStep = (Math.PI * 2) / count;
            const res = [];
            let angle;
            legLength = Math.max(legLength, 35) * resolution; // Minimum distance to get outside the cluster icon.
            for (let i = 0; i < count; ++i) {
                // Clockwise, like spiral.
                angle = Math.PI / 2 + i * angleStep;
                res.push([
                    clusterCenter[0] + legLength * Math.cos(angle),
                    clusterCenter[1] + legLength * Math.sin(angle),
                ]);
            }
            return res;
        }
        function clusterHullStyle(cluster) {
            if (cluster !== t.clusterInfo.hoverFeature) {
                return;
            }
            const originalFeatures = cluster.get('features');
            const points = originalFeatures.map(feature => feature.getGeometry().getCoordinates());
            return new ol.style.Style({
                geometry: new ol.geom.Polygon(points),
                fill: new ol.style.Fill({
                    color: 'rgba(255, 153, 0, 0.4)',
                }),
                stroke: new ol.style.Stroke({
                    color: 'rgba(204, 85, 0, 1)',
                    width: 1.5,
                }),
            });
        }
        function clusterStyle(feature) {
            const size = feature.get('features').length;
            if (size > 1) {
                return [
                    new ol.style.Style({
                        image: new ol.style.Circle({
                            radius: 20,
                            fill: new ol.style.Fill({
                                color: 'rgba(255, 153, 102, 0.3)',
                            }),
                        }),
                    }),
                    new ol.style.Style({
                        image: new ol.style.Circle({
                            radius: 14,
                            fill: new ol.style.Fill({
                                color: 'rgba(255, 165, 0, 0.7)',
                            }),
                        }),
                        text: new ol.style.Text({
                            text: size.toString(),
                            fill: new ol.style.Fill({
                                color: '#fff',
                            }),
                            stroke: new ol.style.Stroke({
                                color: 'rgba(0, 0, 0, 0.6)',
                                width: 3,
                            }),
                        }),
                    }),
                ];
            } else {
                const originalFeature = feature.get('features')[0];
                return clusterMemberStyle(originalFeature);
            }
        }
    }
    clearCluster() {
        const t = this;
        if (t.clusterInfo.clusterHulls) {
            t.state.gis.removeLayer(t.clusterInfo.clusterHulls);
            t.clusterInfo.clusterHulls = null;
        }
        if (t.clusterInfo.clusters) {
            t.state.gis.removeLayer(t.clusterInfo.clusters);
            t.clusterInfo.clusters = null;
        }
        if (t.clusterInfo.clusterCircles) {
            t.state.gis.removeLayer(t.clusterInfo.clusterCircles);
            t.clusterInfo.clusterCircles = null;
        }
        t.props.mapPoints.map(item => {
            if (t.GM.getGraphic(item.id)) {
                t.GM.removeGraphic(item.id);
            }
        })
        t.addPoint(t.props.mapPoints)
        t.refresh();
    }
    /*公共方法*/
    //判断extent1是否在extent2内部
    containsExtent(e1, e2) {
        let { xmin: xmin1, xmax: xmax1, ymin: ymin1, ymax: ymax1 } = e1;
        let { xmin: xmin2, xmax: xmax2, ymin: ymin2, ymax: ymax2 } = e2;
        return xmin2 > xmin1 && xmax2 < xmax1 && ymin2 > ymin1 && ymax2 < ymax1;
    }
    //将图元z-index设置成最高
    czIndex(id) {
        let t = this;
        $(`#${t.props.mapId}_graphics_layer`).append(t.GM.getGraphic(id).getNode());
    }
    equalsPoint(a, b) {
        return a.x == b.x && a.y == b.y;
    }
    //计算2点间距离 单位m 精确到2位小数
    calculatePointsDistance(fp, ep) {
        console.log(fp, ep)
        let distance = ol.sphere.getDistance(fp, ep);
        console.log(distance)
        return Math.round(distance);
    }
    //计算多个点的距离(常用于线计算)
    calculateDistance(ps) {
        let t = this,
            totalDistance = 0;
        if (ps.length < 0) {
            return 0;
        }
        for (let i = 0; i < ps.length; i++) {
            if (i < ps.length - 1) {
                const distance = t.calculatePointsDistance(ps[i], ps[i + 1])
                console.log(distance)
                totalDistance += distance;
            }
        }
        console.log(totalDistance)
        return Math.round(totalDistance * 100) / 100;
    }
    //处理线和面的 经纬度数据
    dealData(paths) {
        //区别点和圆的经纬度数据处理
        let lnglatAry = [],
            _extent = { xmax: 0, xmin: 0, ymax: 0, ymin: 0 },
            path = [];
        path = paths.map((item, index) => {
            let lng = item[0],
                lat = item[1];
            if (lng > _extent.xmax) {
                _extent.xmax = lng;
            }
            if (lng < _extent.xmin || _extent.xmin == 0) {
                _extent.xmin = lng;
            }
            if (lat > _extent.ymax) {
                _extent.ymax = lat;
            }
            if (lat < _extent.ymin || _extent.ymin == 0) {
                _extent.ymin = lat;
            }
            lnglatAry.push({
                lngX: lng,
                latX: lat,
            });
            return [lng, lat];
        });
        return { lnglatAry, _extent, path };
    }
    //处理点位图元的添加 和 更新
    dealLabelGraphics(id, label) {
        let t = this;
        if (label) {
            let position = (t.GM.getGraphic(id) || {}).geometry || label.position;
            //经纬度转top和left
            let tl = t.state.gis.toScreen(position),
                lbl = { ...label };
            //渲染優化
            if (
                !(tl.y < -50 || tl.x < -50 || tl.y > t.state.gis.height || tl.x > t.state.gis.width)
            ) {
                //设置label的位置(通过定位来实现)
                label.html.css({
                    position: 'absolute',
                    top: tl.y + (label.offset.y || 0) - t.labelLayer.y,
                    left: tl.x + (label.offset.x || 0) - t.labelLayer.x,
                });
                //添加点位到(地图)
                $(`#${t.htmlPointsId}`).append(label.html);
                lbl.add = true;
            } else {
                lbl.add = false;
            }
            //记录下label的dom对象,用于后期修改和删除(基本是删除)
            t.Label[id] = lbl;
        }
    }
    //点的跳动动画
    pointAnimation(id, marker) {
        let t = this;
        //null时关闭跳动
        if (!!marker) {
            if (t.animTimer[id]) {
                clearInterval(t.animTimer[id]);
            }
            t.animTimer[id] = setInterval(() => {
                //点被隐藏时,没有执行,定时不关
                if (marker.symbol) {
                    let shape = { ...marker.symbol };
                    //初始数据  点位有变动,重新刷新数据
                    if (!t.animCount[id] || shape.yoffset != t.animCount[id].now) {
                        t.animCount[id] = {
                            start: shape.yoffset,
                            now: shape.yoffset,
                            notation: -1,
                        };
                    }
                    if (t.animCount[id].now - t.animCount[id].start == 20) {
                        t.animCount[id].notation = -1;
                    }
                    if (t.animCount[id].now - t.animCount[id].start == 0) {
                        t.animCount[id].notation = 1;
                    }
                    shape.yoffset = t.animCount[id].now =
                        t.animCount[id].now + t.animCount[id].notation * 2;
                    marker.symbol.setOffset(shape.xoffset, shape.yoffset);
                    t.state.gis.graphics.refresh();
                }
            }, 35);
        } else {
            clearInterval(t.animTimer[id]);
        }
    }
    moveAnimation() {
        let t = this;
        if (t.moveToTimer) {
            clearInterval(t.moveToTimer);
        }
        t.moveToTimer = setInterval(() => {
            for (let i = 0; i < t.movePoints.length; i++) {
                t.movePoints[i].waitTime += 10;
                t.movePoints[i].deleteTime -= 10;
            }
            t.movePoints.sort((x, y) => {
                return y.waitTime - x.waitTime;
            });
            let nowMovePoints = t.movePoints.slice(0, 10),
                deleteIndex = [];
            for (let i = 0; i < nowMovePoints.length; i++) {
                let { id, rx, ry, waitTime, deleteTime, ddeg } = nowMovePoints[i];
                let gc = t.GM.getGraphic(id);
                if (!gc || !gc._graphicsLayer) {
                    clearInterval(t.moveToTimer);
                } else {
                    let gg = gc.getGeometry();
                    let tx = gg[0] + rx, ty = gg[1] + ry;
                    gc.setGeometry([tx, ty])
                    t.movePoints[i].waitTime = 0;
                    if (deleteTime <= 0) {
                        deleteIndex.push(i);
                    }
                }
            }
            deleteIndex.sort((a, b) => { return b - a });
            for (let i = 0; i < deleteIndex.length; i++) {
                t.movePoints.splice(deleteIndex[i], 1);
            }
            if (nowMovePoints.length == 0) {
                clearInterval(t.moveToTimer);
            }
        }, 10);
    }
    //点位移动动画效果
    moveTo(id, lnglat, delay, autoRotation, urlright, urlleft) {
        delay = delay || 3;
        let t = this,
            timer = 10;
        delay = eval(delay) * 1000;
        let count = delay / timer,
            gc = this.GM.getGraphic(id);
        let s = gc.geometry,
            e = { x: lnglat[0], y: lnglat[1] };
        if (t.equalsPoint(s, e)) {
            return false;
        } else {
            let ddeg = 0,
                url = null;
            //计算角度,旋转
            if (autoRotation) {
                //自己实现旋转
                ddeg = t.rotateDeg(gc.geometry, lnglat);
                if (urlleft && ddeg < -90 && ddeg > -270) {
                    ddeg += 180;
                    url = urlleft;
                } else {
                    url = urlright;
                }
                gc.setStyle(new ol.style.Style({
                    image: new ol.style.Icon({
                        src: url,
                        rotation: Math.PI / 180 * ddeg,
                    })
                }))
            }
            //拆分延迟移动定位
            let rx = (e.x - s.x) / count,
                ry = (e.y - s.y) / count;
            let isHave = false;
            for (let i = 0; i < t.movePoints.length; i++) {
                if (t.movePoints[i].id == id) {
                    t.movePoints.splice(i, 1, {
                        id,
                        rx,
                        ry,
                        waitTime: 0,
                        deleteTime: delay,
                    });
                    isHave = true;
                }
            }
            if (!isHave) {
                t.movePoints.push({
                    id,
                    rx,
                    ry,
                    waitTime: 0,
                    deleteTime: delay,
                });
            }
        }
    }
    //点位角度旋转(以指向东(右)为0°)
    rotateDeg(sp, ep) {
        let t = this;
        let spLngLat = sp;
        if (Array.isArray(sp)) {
            spLngLat = new ol.geom.Point(sp[0], sp[1]);
        }
        let s = t.state.gis.getPixelFromCoordinate(spLngLat),
            //获取当前点位的经纬度
            e = t.state.gis.getPixelFromCoordinate(new ol.geom.Point(ep[0], ep[1])),
            deg = 0;
        if (e.x != s.x) {
            var tan = (e.y - s.y) / (e.x - s.x),
                atan = Math.atan(tan);
            deg = (atan * 360) / (2 * Math.PI);
            //degree  correction;
            if (e.x < s.x) {
                deg = -deg + 90 + 90;
            } else {
                deg = -deg;
            }
            deg = -deg;
        } else {
            var disy = e.y - s.y;
            var bias = 0;
            if (disy > 0) bias = -1;
            else bias = 1;
            if (disy == 0) bias = 0;
            deg = -bias * 90;
        }
        return deg;
    }
    //对比对象数据是否相等
    deepEqual(a, b) {
        return Immutable.is(Immutable.fromJS(a), Immutable.fromJS(b));
    }
    //数据解析(分析,新增,更新,删除对应的数据)
    dataMatch(oldData, newData, type) {
        let onlyOldData = Set(oldData)
            .subtract(Set(newData))
            .toJS();
        let onlyNewData = Set(newData)
            .subtract(Set(oldData))
            .toJS();
        let onlyOldIDs = onlyOldData.map(item => item[type]);
        let onlyNewIDs = onlyNewData.map(item => item[type]);
        let updateDataIDs = Set(onlyOldIDs)
            .intersect(Set(onlyNewIDs))
            .toJS();
        let updatedData = onlyNewData.filter(item => updateDataIDs.indexOf(item[type]) > -1);
        let replacedData = onlyOldData.filter(item => updateDataIDs.indexOf(item[type]) > -1);
        let deletedDataIDs = onlyOldIDs.filter(oldID => updateDataIDs.indexOf(oldID) == -1);
        let addedData = onlyNewData.filter(item => updateDataIDs.indexOf(item[type]) == -1);

        return { deletedDataIDs, addedData, updatedData, replacedData };
    }
    //处理需要增加图元的数据(避免意外问题)
    dealAdd(ary, ids) {
        let ads = [],
            otherupds = [];
        for (let i = 0; i < ary.length; i++) {
            if (ids.indexOf(ary[i].id) > -1) {
                otherupds.push(ary[i]);
            } else {
                ads.push(ary[i]);
            }
        }
        return { ads, otherupds };
    }
    //处理需要更新图元的数据(避免意外问题)
    dealUpdate(ary, ids) {
        let upds = [],
            otherads = [];
        for (let i = 0; i < ary.length; i++) {
            if (ids.indexOf(ary[i].id) > -1) {
                upds.push(ary[i]);
            } else {
                otherads.push(ary[i]);
            }
        }
        return { upds, otherads };
    }

    render() {
        let t = this;
        let _map = this.props;
        return <div id={_map.mapId} style={{ width: '100%', height: '100%' }}></div>;
    }
    //初始化
    componentDidMount() {
        let t = this;
        t.loadMapComplete.then(() => {
            t.init();
        });
    }
    //已加载组件，收到新的参数时调用
    componentWillReceiveProps(nextProps, prevProps) {
        let t = this;
        //点/线旧数据
        let { pointIds, lineIds, polygonIds, circleIds, drawIds } = t.state;
        let { point, polyline, polygon, circle, rectangle } = drawIds;
        //点/线新数据
        let {
            mapPoints = [], mapLines = [], mapPolygons = [], mapCircles = [], customizedBoundary = [],
            isOpenTrafficInfo, boundaryName, heatMapData,
            mapVisiblePoints, setVisiblePoints,
            setCenter, mapCenter,
            setZoomLevel, mapZoomLevel,
            setCluster, mapCluster,
            isRangingTool, mapRangingTool,
            isRemove, mapRemove,
            mapDraw, isDraw, isCloseDraw,
            editGraphicId, isDoEdit, isEndEdit,
            mapPointCollection, isclearAllPointCollection,
            isSetAreaRestriction, areaRestriction, isClearAreaRestriction,
            isClearAll
        } = nextProps;
        // 等待地图加载
        if (!t.state.mapCreated) return;
        /*点数据处理
            pointData[2]相同的点,执行刷新
            pointData[1]的数据在idsForGraphicId中不存在的,执行新增
            pointData[0]数据中多余的id,执行删除
        */
        if (mapPoints instanceof Array && t.props.mapPoints instanceof Array && !t.deepEqual(mapPoints, t.props.mapPoints)) {
            let oldMapPoints = t.props.mapPoints;
            let newMapPoints = mapPoints;
            //过滤编辑的图元
            if (!!t.editId) {
                oldMapPoints = t.props.mapPoints.filter((item) => { return item.id !== editGraphicId });
                newMapPoints = mapPoints.filter((item) => { return item.id !== editGraphicId });
            }
            let { deletedDataIDs, addedData, updatedData } = t.dataMatch(oldMapPoints, newMapPoints, 'id');
            let { ads, otherupds } = t.dealAdd(addedData, [...pointIds, ...point]);
            let { upds, otherads } = t.dealUpdate(updatedData, [...pointIds, ...point]);
            //删在增之前,(因为增加后会刷新pointIds的值,造成多删的问题)
            for (let id of deletedDataIDs) {
                t.removeGraphic(id, 'point');
            }
            //增加
            t.addPoint([...ads, ...otherads]);
            //更新
            t.updatePoint([...upds, ...otherupds]);
        }
        /*
            线数据处理
            先全删除,再新增
        */
        if (mapLines instanceof Array && t.props.mapLines instanceof Array && !t.deepEqual(mapLines, t.props.mapLines)) {
            let oldMapLines = t.props.mapLines;
            let newMapLines = mapLines;
            if (!!t.editId) {
                oldMapLines = t.props.mapLines.filter((item) => { return item.id !== editGraphicId });
                newMapLines = mapLines.filter((item) => { return item.id !== editGraphicId });
            }
            let { deletedDataIDs, addedData, updatedData } = t.dataMatch(oldMapLines, newMapLines, 'id');
            let { ads, otherupds } = t.dealAdd(addedData, [...lineIds, ...polyline]);
            let { upds, otherads } = t.dealUpdate(updatedData, [...lineIds, ...polyline]);
            //删在增之前,(因为增加后会刷新pointIds的值,造成多删的问题)
            for (let id of deletedDataIDs) {
                t.removeGraphic(id, 'line');
            }
            //增加
            t.addLine([...ads, ...otherads]);
            //更新
            t.updateLine([...upds, ...otherupds]);
        }
        /*
            面数据处理
            先全删除,再新增
        */
        if (mapPolygons instanceof Array && t.props.mapPolygons instanceof Array && !t.deepEqual(mapPolygons, t.props.mapPolygons)) {
            let oldMapPolygons = t.props.mapPolygons;
            let newMapPolygons = mapPolygons;
            if (!!t.editId) {
                oldMapPolygons = t.props.mapPolygons.filter((item) => { return item.id !== editGraphicId });
                newMapPolygons = mapPolygons.filter((item) => { return item.id !== editGraphicId });
            }
            let { deletedDataIDs, addedData, updatedData } = t.dataMatch(oldMapPolygons, newMapPolygons, 'id');
            let { ads, otherupds } = t.dealAdd(addedData, [...rectangle, ...polygon, ...polygonIds]);
            let { upds, otherads } = t.dealUpdate(updatedData, [...rectangle, ...polygon, ...polygonIds]);
            //删在增之前,(因为增加后会刷新pointIds的值,造成多删的问题)
            for (let id of deletedDataIDs) {
                t.removeGraphic(id, 'polygon');
            }
            //增加
            t.addPolygon([...ads, ...otherads]);
            //更新
            t.updatePolygon([...upds, ...otherupds]);
        }
        /*
            圆数据处理
            先全删除,再新增
        */
        if (mapCircles instanceof Array && t.props.mapCircles instanceof Array && !t.deepEqual(mapCircles, t.props.mapCircles)) {
            let oldMapCircles = t.props.mapCircles;
            let newMapCircles = mapCircles;
            if (!!t.editId) {
                oldMapCircles = t.props.mapCircles.filter((item) => { return item.id !== editGraphicId });
                newMapCircles = mapCircles.filter((item) => { return item.id !== editGraphicId });
            }
            let { deletedDataIDs, addedData, updatedData } = t.dataMatch(oldMapCircles, newMapCircles, 'id');
            let { ads, otherupds } = t.dealAdd(addedData, [...circleIds, ...circle]);
            let { upds, otherads } = t.dealUpdate(updatedData, [...circleIds, ...circle]);
            //删在增之前,(因为增加后会刷新pointIds的值,造成多删的问题)
            for (let id of deletedDataIDs) {
                t.removeGraphic(id, 'circle');
            }
            //增加
            t.addCircle([...ads, ...otherads]);
            //更新
            t.updateCircle([...upds, ...otherupds]);
        }
        //图元编辑调用
        if ((typeof (isDoEdit) == 'boolean' && isDoEdit) || (isDoEdit && isDoEdit !== t.props.isDoEdit)) {
            t.doEdit(editGraphicId);
        }
        // 获取热力图
        if (heatMapData && heatMapData.data && !t.deepEqual(heatMapData, t.props.heatMapData)) {
            t.heatMapOverlay(heatMapData);
        } else if (!t.deepEqual(heatMapData, t.props.heatMapData)) {
            t.clearHeatMap(heatMapData);
        }
        //清空地图
        if ((typeof (isClearAll) == 'boolean' && isClearAll) || (isClearAll && isClearAll !== t.props.isClearAll)) {
            t.clearAll();
        }
        //测距工具调用
        if ((typeof (isRangingTool) == 'boolean' && isRangingTool) || (isRangingTool && isRangingTool !== t.props.isRangingTool)) {
            t.vtxRangingTool(mapRangingTool);
        }
        /*设置指定图元展示*/
        if ((typeof (setVisiblePoints) == 'boolean' && setVisiblePoints) || (setVisiblePoints && setVisiblePoints !== t.props.setVisiblePoints)) {
            t.setVisiblePoints(mapVisiblePoints);
        }
        //设置中心点
        // if ((typeof (setCenter) == 'boolean' && setCenter) || (setCenter && setCenter !== t.props.setCenter)) {
        //     if (!(t.getCurrentCenter().lng == mapCenter[0] && t.getCurrentCenter().lat == mapCenter[1])) {
        //         t.setCenter(mapCenter);
        //     }
        // }
        if (nextProps.mapCenter && nextProps.mapCenter.length > 0 && JSON.stringify(nextProps.mapCenter) !== JSON.stringify(this.props.mapCenter)) {
            t.setCenter(mapCenter);
        }
        //设置点聚合
        if ((typeof (setCluster) == 'boolean' && setCluster) || (setCluster && setCluster !== t.props.setCluster)) {
            t.cluster(mapCluster);
        } else if (setCluster !== t.props.setCluster) {
            t.clearCluster();
        }
        //图元编辑调用
        if ((typeof (isDoEdit) == 'boolean' && isDoEdit) || (isDoEdit && isDoEdit !== t.props.isDoEdit)) {
            t.doEdit(editGraphicId);
        }
        //关闭图元编辑
        if ((typeof (isEndEdit) == 'boolean' && isEndEdit) || (isEndEdit && isEndEdit !== t.props.isEndEdit)) {
            t.endEdit();
        }
        //绘制图元
        if ((typeof (isDraw) == 'boolean' && isDraw) || (isDraw && isDraw !== t.props.isDraw)) {
            t.draw(mapDraw);
        }
        //关闭绘制
        if ((typeof (isCloseDraw) == 'boolean' && isCloseDraw) || (isCloseDraw && isCloseDraw !== t.props.isCloseDraw)) {
            t.closeDraw();
        }
        //单独删除操作
        if ((typeof (isRemove) == 'boolean' && isRemove) || (isRemove && isRemove !== t.props.isRemove)) {
            mapRemove.map((item, index) => {
                t.removeGraphic(item.id, item.type);
            });
        }
        //设置区域限制
        if ((typeof (isSetAreaRestriction) == 'boolean' && isSetAreaRestriction)
            || (isSetAreaRestriction && isSetAreaRestriction !== t.props.isSetAreaRestriction)
            && areaRestriction && !!areaRestriction[0] && !!areaRestriction[1]) {
            t.setAreaRestriction(areaRestriction);
        }
        //关闭区域限制
        if ((typeof (isClearAreaRestriction) == 'boolean' && isClearAreaRestriction) || (isClearAreaRestriction && isClearAreaRestriction !== t.props.isClearAreaRestriction)) {
            t.clearAreaRestriction();
        }
        // 设置地图层级
        if ((typeof (setZoomLevel) == 'boolean' && setZoomLevel) || (setZoomLevel && setZoomLevel !== t.props.setZoomLevel)) {
            t.setZoomLevel(mapZoomLevel);
        }
        // 比例尺控件位置改变
        if (nextProps.showControl && JSON.stringify(nextProps.showControl) != JSON.stringify(t.props.showControl)) {
            t.showControl(nextProps);
        }
    }
    // 地图事件
    //地图点击事件
    clickMap(e) {
        let t = this;
        if (typeof t.props.clickMap === 'function') {
            let obj = t.getMapExtent();
            obj.e = e;
            obj.clickLngLat = {
                lng: e.coordinate ? e.coordinate[0] : undefined,
                lat: e.coordinate ? e.coordinate[1] : undefined,
            };
            obj.pixel = {
                x: e.pixel ? e.pixel[0] : undefined,
                y: e.pixel ? e.pixel[1] : undefined,
            };
            t.props.clickMap(obj);
        }
    }
    // 要素鼠标悬浮事件
    mouseOverGraphic(id, e) {
        let t = this;
        if (t.state.editId == id) return false;
        if (typeof t.props.mouseOverGraphic === 'function') {
            let obj = {
                e,
                id,
                param: t.getGraphic(id),
                top: e.pixel ? e.pixel[0] : undefined, //当前点所在的位置(屏幕)
                left: e.pixel ? e.pixel[1] : undefined,
            };
            t.props.mouseOverGraphic(obj);
        }
    }
    // 要素鼠标移开事件
    mouseOutGraphic(id, e) {
        let t = this;
        //编辑中的图元关闭其他事件返回
        if (t.state.editId == id) return false;
        if (typeof t.props.mouseOutGraphic === 'function') {
            let obj = {
                e,
                id,
                param: t.getGraphic(id),
                top: e.pixel ? e.pixel[0] : undefined, //当前点所在的位置(屏幕)
                left: e.pixel ? e.pixel[1] : undefined,
            };
            t.props.mouseOutGraphic(obj);
        }
    }
    //地图拖动之前事件
    dragMapStart(e) {
        let t = this;
        if (typeof t.props.dragMapStart === 'function') {
            let obj = t.getMapExtent();
            obj.e = e;
            t.props.dragMapStart(obj);
        }
    }
    //地图拖动结束后事件
    dragMapEnd(e) {
        let t = this;
        if (typeof t.props.dragMapEnd === 'function') {
            let obj = t.getMapExtent();
            obj.e = e;
            t.props.dragMapEnd(obj);
        }
    }
    //热力图
    heatMapOverlay(d = {}) {
        let t = this;
        let cg = {
            radius: 20,
            max: 100,
            visible: true,
            opacity: 0.7,
            gradient: ['#00f', '#0ff', '#0f0', '#ff0', '#f00'],
        };
        if (d.config) {
            cg = { ...cg, ...d.config };
        }
        let gradient = [];
        if (cg.gradient) {
            for (let key in cg.gradient) {
                gradient.push(cg.gradient[key])
            }
            cg.gradient = gradient;
        }
        // if(d.data){
        //     t.state.pointIds = [];
        //     t.pointLayers.map(item => {
        //         t.state.gis.removeLayer(item.layer);
        //         t.pointLayers=[];
        //     })
        // }
        const heatData = {
            type: 'FeatureCollection',
            features: (d.data || []).map(item => {
                return {
                    type: 'Feature',
                    properties: {
                        weight: item.count ? item.count / 100 : 0.5,
                    },
                    geometry: {
                        type: 'Point',
                        coordinates: [item.lng, item.lat],
                    }
                }
            })
        }
        let heatSource = new ol.source.Vector({
            features: new ol.format.GeoJSON().readFeatures(heatData)
        })
        t.heatmap = new ol.layer.Heatmap({
            name: 'heatmap',
            source: heatSource,
            radius: cg.radius,
            visible: cg.visible,
            blur: eval(cg.opacity) * 100,
            gradient: gradient,
            weight: (e) => {
                return e.getProperties().count;//根据权重展示热力图！关键点，weight范围为：0-1！！！
            },
        });
        t.state.gis.addLayer(t.heatmap);

    }
    clearHeatMap() {
        const t = this;
        if (t.heatmap)
            t.state.gis.removeLayer(t.heatmap);
        t.heatmap = null;
        t.refresh();
    }
    //地图移动之前事件
    moveStart(e) {
        let t = this;
        if (typeof t.props.moveStart === 'function') {
            let obj = t.getMapExtent();
            obj.e = e;
            t.props.moveStart(obj);
        }
    }
    //地图移动结束后事件
    moveEnd(e) {
        let t = this;
        if (typeof t.props.moveEnd === 'function') {
            let obj = t.getMapExtent();
            obj.e = e;
            t.props.moveEnd(obj);
        }
    }
    //地图更改缩放级别开始时触发触发此事件
    zoomStart(e) {
        let t = this;
        if (typeof (t.props.zoomStart) === 'function') {
            let obj = t.getMapExtent();
            obj.e = e;
            t.props.zoomStart(obj);
        }
    }
    //地图更改缩放级别结束时触发触发此事件
    zoomEnd(e) {
        let t = this;
        if (typeof (t.props.zoomEnd) === 'function') {
            let obj = t.getMapExtent();
            obj.e = e;
            t.props.zoomEnd(obj);
        }
    }
    // 图元点击事件
    clickGraphic(id, e) {
        let t = this;
        if (id) {
            //编辑中的图元关闭其他事件返回
            if (t.editId == id) return false;
            if (typeof t.props.clickGraphic === 'function') {
                const [clientX, clientY] = e.pixel;
                let param = t.getGraphic(id, clientX, clientY);
                let obj = {
                    param,
                    type: param.geometry.type, //图元类型
                    attributes: { ...param.attributes.other, ...{ config: param.attributes.config } }, //添加时图元信息
                    top: clientY, //当前点所在的位置(屏幕)
                    left: clientX,
                    e: e,
                };
                t.props.clickGraphic(obj);
            }
        }
    }
    componentWillUnmount() {
        //关闭moveTo定时
        let t = this;
        if (t.moveToTimer) {
            clearInterval(t.moveToTimer);
        }
        //关闭animation定时
        for (let j in t.animTimer) {
            if (t.animTimer[j]) {
                clearInterval(t.animTimer[j]);
            }
        }
        window.VtxMap && window.VtxMap[t.state.mapId] && (window.VtxMap[t.state.mapId] = null);
    }
}
export default OlMap;

class Popup extends React.Component {
    constructor(props) {
        super();
        this.map = props.map;
        this.position = props.position;
        this.overlay = null;
        this.container = null;
        this.innerHTML = props.innerHTML;
        this.closeble = props.close;
    }

    // 弹出框
    showPopup() {
        const t = this;
        this.removePopup()
        // 获取弹出层DOM
        t.container = document.createElement("div");
        t.container['className'] = "ol-popup";
        if (t.closeble) {
            let close = document.createElement("a");
            close['className'] = "ol-popup-closer";
            close.addEventListener("click", (e) => {
                t.removePopup();
            })
            t.container.appendChild(close);
        }
        let content = document.createElement("div");
        t.container.appendChild(content);
        if (t.overlay) {
        } else {
            // 创建Overlay弹出层绑定DOM
            t.overlay = new ol.Overlay({
                element: t.container,
                autoPan: {
                    animation: {
                        duration: 250
                    }
                }
            })
            // 添加到map
            t.map.addOverlay(t.overlay)
        }
        // 弹出层内容
        content.innerHTML = t.innerHTML;
        // 设置弹出层位置即可出现
        t.overlay.setPosition(t.position)
    }
    // 清除弹出框
    removePopup() {
        if (this.overlay) {
            this.container.remove();
            // 设置位置undefined可达到隐藏清除弹出框
            this.overlay.setPosition(undefined);
            this.overlay = null;
        }
    }
}

function getRgbColor(color, opacity) {
    const reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
    if (!reg.test(color) && typeof (color) !== 'string') {
        return;
    }
    let newStr = color.toLowerCase().replace(/\#/g, '');
    let len = newStr.length;
    if (len == 3) {
        let t = '';
        for (var i = 0; i < len; i++) {
            t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1));
        }
        newStr = t;
    }
    let arr = []; //将字符串分隔，两个两个的分隔
    for (var i = 0; i < 6; i = i + 2) {
        let s = newStr.slice(i, i + 2);
        arr.push(parseInt('0x' + s));
    }
    return 'rgba(' + arr.join(',') + ',' + opacity + ')';
}

// 压缩图片的方法
function canvasDataURL(path, obj, callback) {
    var img = new Image();
    img.src = path;
    img.setAttribute("crossOrigin", 'Anonymous')
    img.onload = function () {
        var that = this;
        // 默认按比例压缩
        var w = that.width,
            h = that.height,
            scale = w / h;
        w = obj.width || w;
        h = obj.height || (w / scale);
        var quality = 0.7;  // 默认图片质量为0.7
        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // 创建属性节点
        var anw = document.createAttribute("width");
        anw.nodeValue = w;
        var anh = document.createAttribute("height");
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
            quality = obj.quality;
        }
        // quality值越小，所绘制出的图像越模糊
        var base64 = canvas.toDataURL('image/png', quality);
        // 回调函数返回base64的值
        callback(base64);
    }
}
